<template>
  <div class="user-index">
    <div class="page-content-new flex-box-div">
      <otherHeaderTop
        headerTitle="个人中心"
        :showBalanceOne="false"
        :showBalanceTwo="false"
      ></otherHeaderTop>
      <div class="user-index-content">
        <!-- 头像 -->
        <div class="head-index-box">
          <div class="head-avatar-box">
            <div class="avatar-left">
              <img
                class="avatar-img"
                :src="`${$getFullPath(obj.avatar)}`"
                alt=""
                @click="showUserDetails = true"
              />
              <!-- <img class="avatar-img" :src="obj.avatar ? obj.avatar : '../../assets/images/default-header.png'" alt=""
                @click="showUserDetails = true" /> -->
              <div class="avatar-text">
                <span>{{ obj.nickName }}</span>
                <span class="desc">邀请码:{{ obj.invitationCode }}</span>
              </div>
            </div>
            <div class="avatar-right">
              <img
                src="../../assets/image3/home/edit.png"
                alt=""
                class="edit-icon"
                @click="showUserDetails = true"
              />
              <div
                class="copy-icon"
                v-clipboard:copy.native="obj.invitationCode"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <img src="../../assets/image3/home/copy.png" alt="" />
              </div>
            </div>
          </div>
          <div class="head-line-box"></div>
          <div class="head-vip-box">
            <span>vip{{ obj.vipLevel }}</span>
            <div style="display: flex">
              <span>{{ vipLeverData.rate }}/{{ vipLeverData.maxRate }}</span>
              <div class="vip-btn" @click="showLevel = true">vip奖励</div>
            </div>
          </div>
        </div>

        <div class="page-nav-box">
          <div class="nav-item" @click="goPersonal">
            <img
              class="nav-item-img"
              src="../../assets/image3/home/accountRecords.png"
              alt=""
            />
            <div class="text">账户记录</div>
          </div>
          <div class="nav-item" @click="showSteam = true">
            <img
              class="nav-item-img"
              src="../../assets/image3/home/transactionLink.png"
              alt=""
            />
            <div class="text">交易链接</div>
          </div>
          <div class="nav-item" @click="showChangePwd = true">
            <img
              class="nav-item-img"
              src="../../assets/image3/home/passwordModification.png"
              alt=""
            />
            <div class="text">密码修改</div>
          </div>
          <div class="nav-item" @click="goHighTime">
            <img
              class="nav-item-img"
              src="../../assets/image3/home/highlight.png"
              alt=""
            />
            <div class="text">高光时刻</div>
          </div>
        </div>

        <!-- <div
          v-if="obj.parentInvitationCode == ''"
          class="invite-code-box"
          @click="showBindCode = true"
        > -->
        <div
          v-if="obj.parentInvitationCode == ''"
          class="invite-code-box"
          @click="showBindCode = true"
        >
          <img
            class="invite-code-icon"
            src="../../assets/image3/home/InvitationCodeIcon.png"
            alt=""
          />
          <img
            class="invite-code-text"
            src="../../assets/image3/home/InvitationCodeText.png"
            alt=""
          />
        </div>
        <div class="bottom-nav-box">
          <div class="nav-row" @click.stop="showSetting = true">
            <div class="label">声音设置</div>
            <div class="right-text">
              <img
                src="../../assets/image3/home/leftArrow.png"
                alt=""
                class="arrow-right-icon"
              />
            </div>
          </div>
          <div class="nav-row" @click.stop="showRealNameFn()">
            <div class="label">实名认证</div>
            <div class="right-text">
              <div class="text">
                <span v-if="obj.isRealCheck == 1">已认证</span>
                <span v-else>未认证</span>
              </div>
              <img
                src="../../assets/image3/home/leftArrow.png"
                alt=""
                class="arrow-right-icon"
              />
            </div>
          </div>
          <div class="nav-row">
            <div class="label">手机绑定</div>
            <div class="right-text">
              <div class="text">
                <span>{{ obj.userName }}</span>
              </div>
              <img
                src="../../assets/image3/home/leftArrow.png"
                alt=""
                class="arrow-right-icon"
              />
            </div>
          </div>
        </div>
        <div class="bottom-info" v-if="!$store.state.LOGIN_IS_SHOW">
          <div @click="showLogout = true" class="exit-btn">退出登录</div>
          <!-- <div class="about-info">
          <div>
            <span @click="goUserAgreement"> 《用户协议》</span>
          </div>
          <div>
            <text @click="goPrivacy"> 《隐私政策》</text>
          </div>
        </div> -->
        </div>
      </div>
    </div>
    <!-- 退出弹框 -->
    <modalLogout
      :showModal="showLogout"
      @close="showLogout = false"
      @confirm="handleLogout"
    >
    </modalLogout>
    <!-- 实名认证 -->
    <modalRealName
      :showModal="showRealName"
      @close="showRealName = false"
      @confirm="handleConfirmName"
    >
    </modalRealName>
    <!-- 设置 -->
    <modalSetting
      :showModal="showSetting"
      :showCancel="false"
      @close="showSetting = false"
      @confirm="handleConfirmSetting"
    >
    </modalSetting>
    <!-- 绑定邀请码 -->
    <modalBindCode
      :showModal="showBindCode"
      @close="showBindCode = false"
      @confirm="handleConfirmBindCode"
    >
    </modalBindCode>
    <!-- 交易链接修改 -->
    <modalSteam
      :showModal="showSteam"
      :transactionLink="obj.transactionLink"
      @close="showSteam = false"
      @confirm="handleConfirmSteam"
    >
    </modalSteam>
    <!-- 密码修改 -->
    <modalPassword
      :showModal="showChangePwd"
      @close="showChangePwd = false"
      @confirm="handleChangePwd"
    >
    </modalPassword>
    <!-- 修改资料 -->
    <modalUserDetails
      :userDetails="obj"
      :showModal="showUserDetails"
      @close="showUserDetails = false"
      @confirm="handleConfirmUserDetails"
    >
    </modalUserDetails>
    <!-- 会员等级列表 -->
    <modalLevel :showModal="showLevel" @close="showLevel = false"> </modalLevel>
  </div>
</template>

<script>
import otherHeaderTop from "../../components/otherHeaderTop.vue";
import modalRecycle from "@/components/common/modalRecycle.vue";
import modalLogout from "@/components/common/modalLogout.vue";
import modalRealName from "@/components/common/modalRealName.vue";
import modalSetting from "@/components/common/modalSetting.vue";
import modalBindCode from "@/components/common/modalBindCode.vue";
import modalSteam from "@/components/common/modalSteam.vue";
import modalPassword from "@/components/common/modalPassword.vue";
import modalUserDetails from "@/components/common/modalUserDetails.vue";
import modalLevel from "@/components/common/modalLevel.vue";
import {
  getUserInfo,
  updateUserDetails,
  realNameAuthentication,
  logOut,
  attendance,
  attendance7day,
  getavatar,
  changePW,
  bindBoss,
  getviplist,
  getVipProgress,
} from "@/api/index";
import { removeToken } from "@/api/cookie";

export default {
  components: {
    otherHeaderTop,
    modalRecycle,
    modalLogout,
    modalRealName,
    modalSetting,
    modalBindCode,
    modalSteam,
    modalPassword,
    modalUserDetails,
    modalLevel,
  },
  data() {
    return {
      obj: {},
      safe_top: 0,
      user: {
        level_info: {},
      },
      showEditUserInfo: false,
      showBindCode: false,
      showSettingSound: false,
      showOfferPwd: false,
      showVerify: false,
      showLevelInfo: false,
      effect: true,
      music: true,
      showLogout: false,
      // 实名认证
      showRealName: false,
      // 设置
      showSetting: false,
      // 绑定邀请码
      showBindCode: false,
      // 交易链接
      showSteam: false,
      // 密码修改
      showChangePwd: false,
      // 修改资料
      showUserDetails: false,
      // vip等级进度
      vipLeverData: {},
      // 会员等级列表
      showLevel: false,
      // // 签到
    };
  },
  watch: {
    musicStatus: {
      handler(newValue) {
        this.musicStatus = newValue;
        localStorage.setItem("music", newValue);
        if (this.musicStatus) {
          this.$store.commit("playGlobalMusic");
        } else {
          this.$store.commit("stopGlobalMusic");
        }
      },
    },
    Realnameauthentication: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    changepassword: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    issign: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    islogout: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    changecode: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    isavatar: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
    isbindsteam: {
      handler(newValue) {
        if (newValue) {
          const state = { title: "title", url: "#" };
          // console.log('window.histroy',window);
          window.history.pushState(state, state.title, state.url);
        }
      },
    },
  },
  mounted() {
    let effect = localStorage.getItem("effect");
    let music = localStorage.getItem("music");
    effect = effect == null ? true : JSON.parse(effect);
    music = music == null ? true : JSON.parse(music);
    this.effect = effect;
    this.music = music;
    this.get();
    this.getVipProgress();

    window.addEventListener("popstate", () => {
      this.Realnameauthentication = false;
      this.changepassword = false;
      this.issign = false;
      this.islogout = false;
      this.changecode = false;
      this.isavatar = false;
      this.isbindsteam = false;
    });
  },
  methods: {
    goPersonal() {
      this.$router.push("/personal");
    },
    goHighTime() {
      this.$router.push("/high_time");
    },
    // 获取vip等级进度
    getVipProgress() {
      getVipProgress().then((res) => {
        if (res.data.code == 200) {
          this.vipLeverData = res.data.data;
        }
      });
    },
    // 修改资料
    handleConfirmUserDetails(userDetails, type) {
      if (type == 0) {
        let nickName = { nickName: userDetails.nickName };
        updateUserDetails(nickName).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              duration: 1000,
              message: "修改成功",
              type: "success",
              customClass: "log_success",
            });
            this.showUserDetails = false;
          } else {
            this.$message({
              duration: 1000,
              message: "修改失败",
              type: "warning",
              customClass: "log_warning",
            });
          }
        });
      } else {
        updateUserDetails({ avatar: userDetails.avatar }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              duration: 1000,
              message: "修改成功",
              type: "success",
              customClass: "log_success",
            });
            this.showUserDetails = false;
          } else {
            this.$message({
              duration: 1000,
              message: "修改失败",
              type: "warning",
              customClass: "log_warning",
            });
          }
        });
      }
    },
    // 复制邀请码
    onCopy(e) {
      console.log("onCopy", e);
      this.$message({
        duration: 1000,
        message: "复制成功！",
        type: "success",
        customClass: "log_success",
      });
    },
    onError(e) {
      this.$soundPlay("opFail");
      this.$message({
        duration: 1000,
        message: "复制失败！",
        type: "warning",
        customClass: "log_warning",
      });
    },
    // 修改密码
    handleChangePwd(userInfo) {
      if (userInfo.newPassword == "") {
        this.$message({
          duration: 1000,
          message: "请输入密码",
          type: "warning",
          customClass: "log_warning",
        });
      } else if (userInfo.newPassword == userInfo.confirmPassword) {
        changePW({
          oldPassword: userInfo.oldPassword,
          password: userInfo.newPassword,
          passwordAgain: userInfo.confirmPassword,
        }).then((res) => {
          console.log("changePW", res);
          if (res.data.code == 200) {
            this.showChangePwd = false;
            this.$message({
              duration: 1000,
              message: "密码修改成功，请重新登陆",
              type: "success",
              customClass: "log_success",
            });
            this.$router.push("/");
            this.$bus.$emit("close", true);
            this.$bus.$emit("logOut");
            removeToken();
            this.$store.commit("LOGIN_IS_SHOW", true);
          }
        });
      } else {
        this.$message({
          duration: 1000,
          message: "两次密码输入不一致,请重新输入",
          type: "warning",
          customClass: "log_warning",
        });
      }
    },
    // 绑定交易链接
    handleConfirmSteam(steam) {
      if (steam == "") {
        this.$message({
          duration: 1000,
          message: "请输入STEAM交易链接",
          type: "warning",
          customClass: "log_warning",
        });
      } else {
        this.onbindsteam = false;
        let transactionLink = {
          transactionLink: steam,
        };
        updateUserDetails(transactionLink).then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.showSteam = false;
              this.$message({
                duration: 1000,
                message: "STEAM交易链接绑定成功",
                type: "success",
                customClass: "log_success",
              });
            }, 500);
          } else {
            this.$message({
              duration: 1000,
              message: "STEAM交易链接绑定失败",
              type: "warning",
              customClass: "log_warning",
            });
          }
        });
      }
    },
    // 邀请码
    handleConfirmBindCode(code) {
      if (code == "") {
        this.$message({
          duration: 1000,
          message: "请输入邀请码",
          type: "warning",
          customClass: "log_warning",
        });
      } else {
        bindBoss({ parentInvitationCode: code }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              duration: 1000,
              message: "绑定邀请码成功",
              type: "success",
              customClass: "log_success",
            });
            this.showBindCode = true;
          } else if (res.data.code == 500) {
            this.$message({
              duration: 1000,
              message: res.data.msg,
              type: "success",
              customClass: "log_success",
            });
          }
        });
      }
    },
    // 声音设置
    handleConfirmSetting(effect, music) {
      console.info(effect, music);
      localStorage.setItem("effect", JSON.stringify(effect));
      localStorage.setItem("music", JSON.stringify(music));
      this.effect = effect;
      this.music = music;
      if (music) {
        this.$soundPlay("indexBgm", true);
      } else {
        this.$soundStop("indexBgm");
      }
      this.showSetting = false;
    },
    // 显示实名认证
    showRealNameFn() {
      if (this.obj.isRealCheck == 1) {
        this.$message({
          duration: 1000,
          message: "您已实名认证",
          type: "success",
          customClass: "log_success",
        });
        this.showRealName = false;
      } else {
        this.showRealName = true;
      }
    },
    // 取消退出登录弹框
    openvip() {
      this.isvip = true;
      getviplist().then((res) => {
        console.log(res);
        this.vipmoney = res.data.data;
      });
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    showLogoutFn() {
      // 判断是否已经登录
      if (this.$store.state.LOGIN_IS_SHOW) {
        this.$message({
          duration: 1000,
          message: "请先登录",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      this.showLogout = true;
    },
    handleLogout() {
      logOut().then((res) => {
        if (res.data.code == 200) {
          this.showLogout = false;
          this.$router.push("/");
          this.$bus.$emit("close", true);
          this.$bus.$emit("logOut");
          removeToken();
          this.$store.commit("LOGIN_IS_SHOW", true);
        }
      });
      // getUserInfo().then(res => {
      //   if (res.data.code == 200) {
      //     /* this.$socket.send("logout_userId_" + res.data.data.userId); */
      //     logOut().then(res => {
      //       if (res.data.code == 200) {
      //         this.$router.push("/");
      //         this.$bus.$emit("close", true);

      //         removeToken();
      //         this.show = true;
      //       }
      //     });
      //   }
      // });
    },
    handlechangepwd() {
      if (this.Exampleobj.password == "") {
        this.$message({
          duration: 1000,
          message: "请输入密码",
          type: "warning",
          customClass: "log_warning",
        });
      } else if (this.Exampleobj.password == this.Exampleobj.password1) {
        changePW({
          oldPassword: this.Exampleobj.oldPassword,
          password: this.Exampleobj.password,
          passwordAgain: this.Exampleobj.password1,
        }).then((res) => {
          console.log("changePW", res);
          if (res.data.code == 200) {
            this.changepassword = false;
            this.getUserInfo().then((res) => {
              if (res.data.code == 200) {
                this.$store.commit("USER_INFO", res.data.data);
              }
            });
            this.$message({
              duration: 1000,
              message: "密码修改成功，请重新登陆",
              type: "success",
              customClass: "log_success",
            });
          }
        });
      } else {
        this.$message({
          duration: 1000,
          message: "两次密码输入不一致,请重新输入",
          type: "warning",
          customClass: "log_warning",
        });
      }
    },

    handleConfirmName(item) {
      realNameAuthentication(item).then((res) => {
        if (res.data.code === 200) {
          this.showRealName = false;
          setTimeout(() => {
            this.$message({
              duration: 1000,
              message: "实名认证成功",
              type: "success",
              customClass: "log_success",
            });
            this.get();
          }, 500);
        }
      });
    },
    get() {
      getUserInfo().then((res) => {
        console.log("getUserInfo", res.data.data);
        this.$store.commit("USER_INFO", res.data.data);
        this.obj = res.data.data;
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 新的样式
.user-index .page-content-new {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-bottom: 23.73 * 4.2px;

  @media only screen and (max-width: 430px) {
    padding-bottom: 23.73vw;
  }
}

.user-index .page-content-new .inner-right-box img {
  width: 4 * 4.2px;
  height: 4 * 4.2px;
  margin-right: 0.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 4vw;
    height: 4vw;
    margin-right: 0.67vw;
  }
}

.user-index .user-index-content {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-height: 66.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  // padding-bottom: 2.67 * 4.2px;
  padding: 0 3.81 * 4.2px 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    min-height: 66.67vw;
    // padding-bottom: 2.67vw;
    padding: 0 3.81vw 2.67vw;
    flex: unset !important;
    height: 90vh;
  }
}

.user-index .user-index-content .head-box {
  width: 100%;
  height: 29.76 * 4.2px;
  padding: 0 3.81 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 3.8 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 100vw;
    height: 29.76vw;
    padding: 0 3.81vw;
    margin-top: 3.8vw;
  }
}

.user-index .user-index-content .head-index-box {
  height: 32 * 4.2px;
  border-radius: 1.9 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url("../../assets/images/head-index-box.png") no-repeat center
    center;
  background-size: 100% 100%;

  margin-top: 3.8 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 32vw;
    border-radius: 1.9vw;
    margin-top: 3.8vw;
  }
}

.user-index .user-index-content .head-index-box .head-avatar-box {
  height: 20 * 4.2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5.24 * 4.2px 0 4.05 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 20vw;
    padding: 0 5.24vw 0 4.05vw;
  }
}

.user-index .user-index-content .head-index-box .head-avatar-box .avatar-left {
  display: flex;
  align-items: center;
}

.user-index
  .user-index-content
  .head-index-box
  .head-avatar-box
  .avatar-left
  .avatar-img {
  width: 12.62 * 4.2px;
  height: 12.62 * 4.2px;
  border-radius: 50px;
  margin-right: 1.43 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 12.62vw;
    height: 12.62vw;
    margin-right: 1.43vw;
  }
}

.user-index
  .user-index-content
  .head-index-box
  .head-avatar-box
  .avatar-left
  .avatar-text {
  display: flex;
  flex-direction: column;
  align-items: start;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-size: 3.33 * 4.2px;
  font-weight: 500;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.user-index
  .user-index-content
  .head-index-box
  .head-avatar-box
  .avatar-left
  .avatar-text
  .desc {
  font-size: 2.86 * 4.2px;
  font-weight: 400;
  color: #89d7ff;
  margin-top: 2.86 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.86vw;
    margin-top: 2.86vw;
  }
}

.user-index .user-index-content .head-index-box .head-avatar-box .avatar-right {
  display: flex;
  flex-direction: column;
}

.user-index
  .user-index-content
  .head-index-box
  .head-avatar-box
  .avatar-right
  .edit-icon {
  width: 5.95 * 4.2px;
  height: 5.95 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 5.95vw;
    height: 5.95vw;
  }
}

.user-index
  .user-index-content
  .head-index-box
  .head-avatar-box
  .avatar-right
  .copy-icon {
  width: 5.95 * 4.2px;
  height: 5.95 * 4.2px;
  margin-top: 0.95 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 5.95vw;
    height: 5.95vw;
    margin-top: 0.95vw;
  }
}

.user-index .user-index-content .head-index-box .head-line-box {
  width: 78.81 * 4.2px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid;
  border-image: linear-gradient(
      90deg,
      rgba(1, 167, 177, 0),
      rgba(135, 212, 255, 1),
      rgba(137, 213, 255, 1),
      rgba(1, 167, 177, 0)
    )
    1 1;

  @media only screen and (max-width: 430px) {
    width: 78.81vw;
  }
}

.user-index .user-index-content .head-index-box .head-vip-box {
  height: 9.76 * 4.2px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 12px;
  color: #89d7ff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3.1 * 4.2px 0 2.38 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 9.76vw;
    padding: 0 3.1vw 0 2.38vw;
  }
}

.user-index .user-index-content .head-index-box .head-vip-box .vip-btn {
  width: 16.19 * 4.2px;
  height: 5.09 * 4.2px;
  line-height: 5.09 * 4.2px;
  text-align: center;
  font-size: 2.86 * 4.2px;
  color: #ffffff;
  background: url("../../assets/image3/home/vipBtn.png") no-repeat 0 0;
  background-size: 16.19 * 4.2px 5.09 * 4.2px;
  overflow: hidden;
  margin-left: 2.86 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 16.19vw;
    height: 5.09vw;
    line-height: 5.09vw;
    font-size: 2.86vw;
    background-size: 16.19vw 5.09vw;
    margin-left: 2.86vw;
  }
}

.user-index .user-index-content .user-index-box {
  width: 88.53 * 4.2px;
  height: 28.93 * 4.2px;
  background: url("../../assets/images/top_box_bg1.png") no-repeat 0 0;
  background-size: 88.53 * 4.2px 28.93 * 4.2px;
  margin: 2.4 * 4.2px auto 0 auto;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 88.53vw;
    height: 28.93vw;
    margin: 2.4vw auto 0 auto;
    background-size: 88.53vw 28.93vw;
  }
}

.user-index .user-index-content .user-index-box .avatar-box {
  width: 30 * 4.2px;
  height: 28 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  left: -2.93 * 4.2px;
  top: -3.2 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 30vw;
    height: 28vw;
    left: -2.93vw;
    top: -3.2vw;
  }
}

.user-index .user-index-content .user-index-box .avatar-box:after {
  content: "";
  display: block;
  width: 30 * 4.2px;
  height: 28 * 4.2px;
  background: url("../../assets/images/avatar_outer.png") no-repeat 0 0;
  background-size: 30 * 4.2px 28 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;

  @media only screen and (max-width: 430px) {
    width: 30vw;
    height: 28vw;
    background-size: 30vw 28vw;
  }
}

.user-index .user-index-content .user-index-box .avatar-box .user-avatar {
  width: 13.6 * 4.2px;
  height: 13.6 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 13.6vw;
    height: 13.6vw;
  }
}

.user-index .user-index-content .user-index-box .avatar-box .avatar-touch {
  z-index: 1;
  position: absolute;
  width: 13.6 * 4.2px;
  height: 13.6 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 13.6vw;
    height: 13.6vw;
  }
}

.user-index .user-index-content .user-index-box .nickname {
  width: 71.73 * 4.2px;
  height: 9.6 * 4.2px;
  line-height: 9.6 * 4.2px;
  padding-left: 9.2 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  right: 0.27 * 4.2px;
  top: 0.67 * 4.2px;
  font-size: 4.4 * 4.2px;
  color: #d4d4ff;
  text-align: left;

  @media only screen and (max-width: 430px) {
    width: 71.73vw;
    height: 9.6vw;
    line-height: 9.6vw;
    padding-left: 9.2vw;
    right: 0.27vw;
    top: 0.67vw;
    font-size: 4.4vw;
  }
}

.user-index .user-index-content .user-index-box .nickname .icon {
  width: 4.27 * 4.2px;
  height: 3.6 * 4.2px;
  position: absolute;
  top: 3.2 * 4.2px;
  right: 1.07 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 4.27vw;
    height: 3.6vw;
    top: 3.2vw;
    right: 1.07vw;
  }
}

.user-index .user-index-content .user-index-box .username {
  width: 69.87 * 4.2px;
  height: 8.8 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 8.27 * 4.2px;
  position: absolute;
  right: 0.67 * 4.2px;
  top: 9.6 * 4.2px;
  line-height: 8.8 * 4.2px;
  color: #c2caff;
  font-size: 3.33 * 4.2px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    width: 69.87vw;
    height: 8.8vw;
    padding-left: 8.27vw;
    right: 0.67vw;
    top: 9.6vw;
    line-height: 8.8vw;
    font-size: 3.33vw;
  }
}

.user-index .user-index-content .user-index-box .username .icon {
  width: 4.27 * 4.2px;
  height: 3.6 * 4.2px;
  position: absolute;
  top: 2.53 * 4.2px;
  right: 1.07 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 4.27vw;
    height: 3.6vw;
    top: 2.53vw;
    right: 1.07vw;
  }
}

.user-index .user-index-content .user-index-box .bottom-vip-box {
  width: 88.53 * 4.2px;
  height: 5.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: 1.33 * 4.2px;
  right: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  @media only screen and (max-width: 430px) {
    width: 88.53vw;
    height: 5.33vw;
    left: 0;
    bottom: 1.33vw;
    right: 0;
  }
}

.user-index
  .user-index-content
  .user-index-box
  .bottom-vip-box
  .vip-text
  .vip-logo {
  float: left;
  width: 9.6 * 4.2px;
  height: 4.53 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 9.6vw;
    height: 4.53vw;
  }
}

.user-index .user-index-content .user-index-box .bottom-vip-box .level-bar {
  width: 51.2 * 4.2px;
  height: 2.4 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYAAAAASCAMAAABlwPlxAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADqUExURQAAACVT5SRQzACA/yZV5yZU6CVU5iVV6yVV6iRNyiVL0iNPyiZZ+yVV6CJFsiRP1SZZ+SRS4C1L0iZLySRV5yZNxiRKxSRU4zNN5iFMziJKxiRV6SNNyyRS4CZY8iRPyCFOzSdO2CZY8yRJwiNJwiZY8yRMySJGsiRMyiVY9CVV7SVV7CVV6SVV6CNOzSVLwx9LzR5LwyRNzCZMvSVV6idNySNMzSNOzB9NwSRLySJFsSVU5yBKzCJGsyRLyh8ybiA2fiZb/iZb/x81eCZa+yA3giA7jC*4.2px7yA2fCA2eyA2eh80dB81dyA2fXuTznYAAAA/dFJOUwDUIwL6+9T+/CsiHf7c+Sr+xhE92ShPzAovLdlJvfkqLhr6VFD5ufm4/v7+/f3CIikRuhv+IcLCIbj5/Df8uvt3mMMAAADkSURBVFjD7ZnHDsIwEAUXSCD03ntNKEnovYUQOv//Oxxy5mRZK1k7p3eekWxZBoDFSg8QOAz6AGFNdc4EDrc7rDeqfSKQeA1hSf4RcUYwckgDGrZqwPBBHtD8xzQTAmcSgea/FwYKgOyfAiD7pwDI/nkGeH/ppfUPR9Vc/xwDfA47RZElSZIVhXmIhjydAecA9va4r2fTuU67UgoyDvEYT4BzAPeMa+a7rVq1wDwEhlMA13/IY12sctHHOkRm/uTs3+9lHkJzv/G6432NjCuQcQhOf8Dhn0E3TIBUMnGNROPMQ2x+6XZ4cWBvvUEAAAAASUVORK5CYII=)
    no-repeat 0 0;
  background-size: 51.2 * 4.2px 2.4 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 51.2vw;
    height: 2.4vw;
    background-size: 51.2vw 2.4vw;
  }
}

.user-index
  .user-index-content
  .user-index-box
  .bottom-vip-box
  .level-bar
  .level-active-bar {
  width: 70%;
  height: 2.4 * 4.2px;
  background: url("../../assets/level-active-bar.png") no-repeat 0 0;
  background-size: 51.2 * 4.2px 2.4 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;

  @media only screen and (max-width: 430px) {
    width: 70%;
    height: 2.4vw;
    background-size: 51.2vw 2.4vw;
  }
}

.user-index .user-index-content .user-index-box .bottom-vip-box .num {
  width: 20.8 * 4.2px;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  font-size: 2.67 * 4.2px;
  text-align: center;
  font-weight: normal;
  color: #c2caff;
  white-space: nowrap;

  @media only screen and (max-width: 430px) {
    width: 20.8vw;
    height: 5.33vw;
    line-height: 5.33vw;
    font-size: 2.67vw;
  }
}

.user-index .user-index-content .user-index-box .bottom-vip-box .icon {
  width: 47.6px;
  height: 22.386px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  font-size: 12px;

  @media only screen and (max-width: 430px) {
    width: 12vw;
    height: 5.33vw;
    font-size: 3vw;
  }
}

.user-index .user-index-content .user-index-box .bottom-vip-box .icon img {
  width: 4.27 * 4.2px;
  height: 3.6 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 4.27vw;
    height: 3.6vw;
  }
}

.user-index .user-index-content .page-nav-box {
  width: 100%;
  height: 28.13 * 4.2px;
  padding-top: 3.87 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 430px) {
    height: 28.13vw;
    padding-top: 3.87vw;
  }
}

.user-index .user-index-content .page-nav-box .nav-item {
  width: 20.27 * 4.2px;
  height: 24.27 * 4.2px;
  // float: left;
  // margin-right: 2.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  padding-top: 0.67 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #c2caff;

  @media only screen and (max-width: 430px) {
    width: 20.27vw;
    height: 24.27vw;
    // margin-right: 2.53vw;
    padding-top: 0.67vw;
    font-size: 3.33vw;
    background-size: 20.27vw 24.27vw;
  }
}

.user-index .user-index-content .page-nav-box .nav-item .nav-item-img {
  width: 4rem;
  // height: 8.3 * 4.2px;
  margin-bottom: 0.5rem;
}

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(1) {
//   background: url("../../assets/images/nav_item_bg1-active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(1):hover {
//   background: url("../../assets/images/nav_item_bg1_no_active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(2) {
//   background: url("../../assets/images/nav_item_bg2-active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(2):hover {
//   background: url("../../assets/images/nav_item_bg2_no_active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(3) {
//   background: url("../../assets/images/nav_item_bg3-active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(3):hover {
//   background: url("../../assets/images/nav_item_bg3_no_active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(4) {
//   background: url("../../assets/images/nav_item_bg4-active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item:nth-child(4):hover {
//   background: url("../../assets/images/nav_item_bg4_no_active.png") no-repeat 0 0;
//   background-size: 20.27 * 4.2px 24.27 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     background-size: 20.27vw 24.27vw;
//   }
// }

// .user-index .user-index-content .page-nav-box .nav-item div {
//   margin-bottom: 2.4 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     margin-bottom: 2.4vw;
//   }
// }

.user-index .user-index-content .invite-code-box {
  height: 11 * 4.2px;
  background: url("../../assets/image3/home/InvitationCode.png") no-repeat 0 0;
  background-size: 100% 100%;
  margin: 3.2 * 4.2px auto 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4.05 * 4.2px 0 3.33 * 4.2px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;

  @media only screen and (max-width: 430px) {
    height: 11vw;
    margin: 3.2vw auto 0 auto;
    padding: 0 4.05vw 0 3.33vw;
  }
}

.user-index .user-index-content .invite-code-box .invite-code-icon {
  width: 8.57 * 4.2px;
  height: 8.57 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 8.57vw;
    height: 8.57vw;
  }
}

.user-index .user-index-content .invite-code-box .invite-code-text {
  width: 19.3 * 4.2px;
  height: 4.52 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 19.3vw;
    height: 4.52vw;
  }
}

.user-index .user-index-content .invite-code-box .time-box {
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  left: 48 * 4.2px;
  bottom: 1.33 * 4.2px;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.user-index .user-index-content .invite-code-box .time-box .end-text {
  color: #ffffff;
  font-size: 3.87 * 4.2px;
  padding: 0 2.67 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAAiAgMAAAAL7yzsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURSdL/yZM/ydL/yVM//RGG00AAAAEdFJOU315e3WdQmiKAAAAMElEQVRIx2O4GkoJKGBoYKAEKDA4UKRfYFT/qP5R/aP6R/WP6h/VT4Z+SutvCtsPAA8BNa2QD1DeAAAAAElFTkSuQmCC)
    no-repeat 0 0;
  background-size: 100% 100%;
}

.user-index .user-index-content .invite-code-box .time-box .van-count-down {
  font-size: 3.87 * 4.2px;
  color: #ffffff;
  line-height: 5.87 * 4.2px;
}

.user-index
  .user-index-content
  .invite-code-box
  .time-box
  .van-count-down
  .day-label {
  margin-right: 0.53 * 4.2px;
}

.user-index .user-index-content .invite-code-box .time-box .opt-btn {
  margin-left: 2.67 * 4.2px;
  margin-bottom: 1.33 * 4.2px;
  width: 25.47 * 4.2px;
  height: 7.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL8AAAA3CAMAAABq12uBAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAHFUExURQAAAP/YJf/ZJv/ZJv/VK/+AAP/ZJv/ZJv/ZJv/ZJv/ZJv/XKP/dIv/dKP/ZJv/ZJv/ZJv/jK//ZJv/SHv//AP/eIf/ZJv/bJP/aJv/XKP/SLf/ZJv/aJv/YJv/cK///AP/bKv/YJ//aJ//ZJv/bJP/fKP/WKf/ZJ//aJf/aJ//bLP/ZJlc8IqeHJMakJeXBJtu4JZZ3JHdbI15DIoJlI+7KJrmYJGxQI/fSJquLJIxuI/zWJuK/Jdm2Jf3XJlg9Ita0JfjTJoBkI/rVJqyMJGNIIq6OJLSTJJN1I21RIpJ0I+nFJvXQJlk+Iti1JcOiJezIJtGuJfPOJvvVJrSUJF9EIvrUJvHMJpFyI+3JJpV3JOG9JdKwJYZoI3VZI41vI9KvJWNHIv7YJquMJLOTJHFVI6WFJOC9JYpsI2VKIt+7JXxfI5l6JHRYI5FzJPTPJvnTJqmKJM2rJZx9I1o/Ip9/JO/KJmFFIp+AJJN1JKGBJGRJIltAIqeIJGZLImlNIm1RI6KCJLeWJJR2JNGvJZp7JHBUI4VoI/bRJrCPJOfDJa2NJH1gI2pOI/LNJpx+JNy4JWRIIpt7JIlsI2pPI3VYI4xtI74hOQgAAAArdFJOUwDa7f4SAu8U7PfwEw8m2eT6EusRARfeDtsmEePu7iQDK+ay3xUgJeAi2iMmDFr8AAADwUlEQVRo3t2Z90PiMBTHFcpRRE*4.2px3d67ICIinHje6bn3qbf33nvvvff8ey+joUnatEWwtvf9gbykafLh9WW1FRXuVzgSQoqEKzyp4CIFaVHQo/wy5pf/J/6AFAQKe5ZfqpSBIp7lx4Oijn4YrpMUEI9f/KdCOFNdK7tRtdVUqMhypWTg/3A0EJBqqhQ3qqoGETfUR+nHwcZ/rKm5udbndyW/37d4JQSP1jfoBgWZf2Kbtm50p/eRVugjh5W0YYtLvU+JW3mh70kwSZurFNeLW3lh7JNHEnG/93X8cO4hj6RO8YBiS4X8IS/w+5YwCxodP5b8caDtTK6PrdALip5hswteZi5OtgGZtt8q1BQ1kTILGj1+bfE/IpnDOkBc4TVld4n+fipOi65grITRghbg5s+QOblYpNYbHuahrpHhcvH7fbqVoFT+PLTf0becYBp5odUV8+dyuVmQ/MrlptXsb0N+gzNYqfw7sJ0QVeiG5kdkXhXyg6QDJJ2KMqNmswJ+ucz8sJ/4iAk/auUzstoLQ2Gu8VMc*4.2px19IaRi/qGC3Q+MA27in8H9jJny51JAeZaa5k9ogsU/tezuUvm3MepiAitRcB3q5n0G6Q4swGbGMB4Zn0OzhRIsm6XyX0vkZ/3ZoiidQFMc/yRKPqjONFgfiDKG/GZDrLXc/DBJsvzf8bSoGPK30bH0HKQDLuMfz+Nc2pp/mpuTHOJvRxLwfwI/P2Bu1Jo/C9RnvVVJFrWTtubXLD0/1Dfa/abx087LYgJ1hH8QdbUXuzebvQdz2IRXe8BO4KgwUhzh70AS8b9CPd0wocPPABovuQrDjvCbjd/utMk41PHzVSa41cT4yc/3/FkE/1tgHERWh50NhLP8OM6OaCGn598FrTzZkz5xhj+FZM0vXH81fuUKsMa1Pbcj8WM2/8DDYjH86MYzyh6YHFKUBZ8/4w94T1nwHy/AnVcc4k8jidcvu/wnUeaYyvaU6+VvCytnxq99/t54jjpuaus1aeFPitU88RuMOHv8ccx/mrT1OONU/Njjn8Bhlr6th*4.2px6zfOfZZq76Qw/PksV+JP84RT3tFMMQPgvkOKLxLiFj1+i+RNcKvf8UwJ/j1o4BIoGsNlm+x3ZQvP3n1NJL6l3XXYZ/2jCQIT/FKl4n2p70AH+JJBmjaE9TFLVPur1h+mJ6bqa7r/GXbg7UvqXDI+8/5/b+083flAt5v2zKz9oB7zL7/ep3188ym/gfQ/xY+8HomH2P9R5y/vhdU3rG1dR/MtDHtEyFPvB2JrVaxs1/H8rcXRJN1YjawAAAABJRU5ErkJggg==)
    no-repeat 0 0;
  background-size: 100% 100%;
}

.user-index .user-index-content .bottom-nav-box {
  height: auto;
  padding-top: 2.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: linear-gradient(320deg, #05164e 0%, #0b2db4 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
  border-image: linear-gradient(
      96deg,
      rgba(179, 223, 255, 1),
      rgba(48, 168, 255, 0),
      rgba(172, 220, 255, 1)
    )
    1 1;
    margin-top: 4vw;
}

.user-index .user-index-content .bottom-nav-box .nav-row {
  height: 9 * 4.2px;
  line-height: 9 * 4.2px;
  // background: rgba(8, 46, 110, 0.85);
  // border-radius: 8px;
  // border: 1px solid #2595d6;
  margin-bottom: 1.9 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #ffffff;
  // overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3.1 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255,255,255,0.07);

  @media only screen and (max-width: 430px) {
    height: 9vw;
    line-height: 9vw;
    margin-bottom: 1.9vw;
    font-size: 3.33vw;
    padding: 0 3.1vw;
  }
}
.user-index .user-index-content .bottom-nav-box .nav-row:last-child{
  border-bottom: none;
}

.user-index .user-index-content .bottom-nav-box .nav-row .label {
  color: #ffffff;
}

.user-index .user-index-content .bottom-nav-box .nav-row .right-text {
  display: flex;
  align-items: center;
}

.user-index
  .user-index-content
  .bottom-nav-box
  .nav-row
  .right-text
  .arrow-right-icon {
  width: 4.05 * 4.2px;
  height: 4.05 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 4.05vw;
    height: 4.05vw;
  }
}

.user-index .user-index-content .bottom-info {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 12.93 * 4.2px;
  padding-bottom: 13.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-index .user-index-content .bottom-info .exit-btn {
  width: 33.8 * 4.2px;
  height: 10.35 * 4.2px;
  line-height: 10.35 * 4.2px;
  text-align: center;
  font-size: 3.33 * 4.2px;
  color: #cccced;
  background: url("../../assets/image3/home/exitButton.png") no-repeat 0 0;
  background-size: 33.8 * 4.2px 10.35 * 4.2px;
  overflow: hidden;

  @media only screen and (max-width: 430px) {
    width: 33.8vw;
    height: 10.35vw;
    line-height: 10.35vw;
    font-size: 3.33vw;
    background-size: 33.8vw 10.35vw;
  }
}

.user-index .user-index-content .bottom-info .about-info {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 2.67 * 4.2px;
  padding-top: 4.27 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-index .user-index-content .bottom-info .about-info div {
  margin: 0 4.67 * 4.2px;
}

.user-index .user-index-content .bottom-info .about-info div text {
  color: #74749e;
}

.user-index .user-index-content .bottom-img-mask {
  width: 100 * 4.2px;
  height: 15.47 * 4.2px;
  background: url("../../assets/images/bottom_outer_box_bg.png") no-repeat 0 0;
  background-size: 100 * 4.2px 15.47 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .van-dialog__content {
  padding-top: 8 * 4.2px;
  height: 93.33 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .bottom-btn-wrap {
  width: 100%;
  height: 24.13 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 8 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content {
  width: 100%;
  overflow: hidden;
  padding-top: 2.67 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .nickname {
  width: 100%;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  text-align: center;
  font-size: 4.4 * 4.2px;
  color: #d4d4ff;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .tab-wrap {
  width: 100%;
  height: 11.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 1.87 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .tab-wrap
  .tab-item {
  width: 21.07 * 4.2px;
  height: 9.33 * 4.2px;
  background: url(data:image/png;base64,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*4.2pxqxCZX5Ai6giYzGGj7fYDCsKAB9N6h5Ny8qEoRdAfEN/MQao1EkEmVyBXK*4.2pxewuiYF3cllnh8vpFptVcgEXwQEaj7eUlz4vvRCUnEUr+eZFxYGwEB2+wePx+fwao6iYm68U2tqHY+I1tyLzZEoNt1iEjOMtTU9PTU1NS0tJycqKZ15ZWSkpaWnwhfR0TAh8XI1c5rFITywfBUXg9bgqFWqtqk3AzZymQ3Apm+LjkxKYVhIQptCAhA/hqarsUuLejjC8im59idsrUeZziym61NRkBAdsSQlJSUlfZlJJOGYQEPPViHQw+arU0kcenRgdnRjcHY5ndbSjhQHmUXTIOmQcQbuTSRHEBAxI8Rn4RoSnVSsAz++fGNwThldnHVbbZHKBTlRD0SHrCNydbIgCTMlKIXx8YzHBu6/f5/f7tjwRjlcpVXtUcwEvSIfGNQjXks1hStmcaUBiIOIzJMLSVZnrAc8fCPi3vBqXE4GnhW2l2Gig6eCPo+Ag5JeYFPypLTQgzcdLzOTmV5vtilX9AdDhN3JC8OZn4IUrF2Qm8mDN0nQoRjbF9hWmRAhbOEG+rLRkwOMDntKslq56amp8fGr9k01NOdPulTkBrxpWBp+XjlZFfAJNN402kxlRiNnEQODD9i01ZHI1Sq1aet+G8S++GF//cENDCF5GiaLejBYufyk1tJgum4PZZjItTIgnIc3HM4gQnh3wzn/wwfmhSDyTWAJnhsjAC6XDzkG425gVBiR8eHwBL91QxM2tRngPnT5z5vTQyq6GppC5F8RDMy8+gaZDcDjiDOZEA1J8xL55hiJd7gKt3bEd4z0QiVcrllTncosM84LmTdPNYFoYEPHh4U0A+9JXFC1EeNJr4XklC3IXFq1ID5rXgugI3CxGFc5H7EstQHgSenAj8fIWUXipoeYRulmLFy++gzFBMAKI5l8LsW9TSiHBg215w/kzZ84PrWyIwCsXIryCwpRN2DwOmIdGFtPdwawQH/KPtg9GF+EJFkjEgDf5+WfTG0tOVyQeGVvKPDboaD5kH7U4sgoLEhcKlgjFplX9l8b/NRncll/buw/wyvIWzRYuESxMLCjMImPLITMP4QWj3n6TChngWTPI7IvAm23SH790aTJw+GATGdtXfv/WgWvg4bGdNu92BhQLD/iCeOUm5/Y/XfL5txykztzdR47tPxqBh9btrcMLc682r+ydQ//4ZJC+UO05cvXK/nduxD0mB/dac2/2oryy+UcPvX2Evo4+Mei7euX17Tc095jbWyi88JWbu0BYvigvY/7Jo+++SC7zOTkHt/gDl68c32qClSuIXrls8NF0gNfCCdv3KLw5+/a+RvLlTQcPByanLv/x+G8i9j360JjBzrYcuu3hUwMfahI*4.2pxYvrIpteU9OT6yf/PT519amtYnxqFISfGmweajDzIs9cibe2BOMR5TQ0PLx+/LPPxy8CnjnizA3lY+NGQA8tfWOBC5VEHIbX1NCwcgjOuNMXN2D3dKE3Fg7hm8nCfeo26sIXNA/ue+g6KhGbwvG6Vg7BDeGjKYSHL1T4vkeeaJxsdm+j2VG3ZYxXMY3X1bXyAcD76+SGrfXaqNsy4WPpLs/hhL01yFOoXhGF9xHCe2iVHeFlGsLeGvC+pV5CDL6DyGMtm7yEEtDQplEvtWp4hjvLYuOBe9RLLTktK54aX7hXsfKO5NB0xLx09M4lWYLK2HMP3EMPSXjnBnME5BXewsIrnE4TUHQoS0AlMaSVdRVhG8sQPNxOw8Zi16ryucWJhlg5DA6DOYyWWDkMHl+kE8xVeaLx1o9/+un5QP9WdRVOYtA5lqxbkgEK0uEEmsymHraG4qFTY2p8fDLQ*4.2pxrj6Yx8w/8hf8bnG9HCldjaHdbuaTy4ErxxOBAIXPTTeKIaHi/Ix172MYHKPiZTdDVGlFuWeN1OfRhe3KtwYwkEPuzfagc82Phq+BQfDchO7nYTnRql6DK5gja8cF09y6bx4L63xef3+ycefcTikSE8I8XHbuY7JSTzjRPzOjgzZDaLVN/aHIa3Z3CC4JHkLUnMY0KqbhDM9TNTM8CxCqfrBgaYd6LMYmSeWex2ujo6w/B2D06Mjo76lp+gyhqZIhEquiSioguuujBecSFFF1x1QcYhOJ1AI1cKwTxrY9/mZWMheHfv8KFCwvITJrtHhopCuGSFa1asl6xwzQqVrASaNlyyAvN6N64Jw7tnFLt3v7TdWyVTyvM1GrredysKfqi4qMlvU6qEnnq3Q9/a1/mzdWfD8HwEb0BhsVXJVEp5m1weVS5ltFoaXi6dK1cqVTKzze5G1ebmx0rPlj4fjfeg3mGyeD1mXGqOKjYzXGsOKzbLhGatTWwxAV0H0I2V/mhXDLxGq0PRXi+2eaqqtFqzObxUz2SlPrRUr9VqPTabWG1xS516oHsZ0f0kLhpv50ijfkBqcrdb7KjNAfU54EaHcjYaHWZTjQ71uKei3a2QOq2u1rXRdDTe6p29I60u6wDqEZHi7g2qTYStLhG6TQT1iDgrra7Gjr7mx6PognhP9/SuRR02qMHG6XzBeUt6bEpwgw3qsOno6+1EqyKCjsIbXf0s6U9C7UJU5xDdosRGh1KwAwr1J3WT/qT3or2j8Hz+X/76LqIfBHUXg9oWs+WL6iSrqMCdZeuivQviXX7zbx//mS19/Pf9B67XPTc2FsM7dKihsfVfuPA+i7p8Zf+B67Yfrnl+V3TL4zMv4XbDc+dOsSjf1WNv7cv5X3o6n3nx2+zrd799+6W9Xf8t2n8A3PKfYdbqLRoAAAAASUVORK5CYII=)
    no-repeat 0 0;
  background-size: 21.07 * 4.2px 9.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #4f609f;
  font-size: 3.33 * 4.2px;
  margin: 0 4.8 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .tab-wrap
  .tab-item.sel {
  background: url(data:image/png;base64,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*4.2pxaISQ/P38xzndQvspW0GDkuDABmkej0bhcEp3HSPg6O566N5Y3/8KGhqYddSZzwKp0S4CWX1FSUuJcBamsXIIil8u/wlpgMDxoZSWawQlTVSCnS+KxOYZNCXin1w/1tXS0+bxKnQhszlq5vKxKoaiqqhIIxOK5nEQsFgiq0CRlwK2tdVYIXTql19f5UCIeFE87TBjdIiHgyhSAalWrZeXl5TmQNA4Cw8LoMrW6tRWgCkVZbYVQ4rYF6hPxtjdB8QJWj0RYATixWCaTZeeoVGlp/OWQVA4Cw/Lz0lSqnOxsmVoGwLLafJfb6DA/nYjXXmey2I06V74TdGBTqfh8Po+XmrUQkpnMdjLRsKmpPB7MwleBUCZQAE9nJCwU70gUr9/f6fN6JJqKWqzL5ufl8XhZgMvMTF45nf0gYubCrCwej5eHfWJFbYVGp7TTvFORvOL+Qbi2y0RCZxmlIysHNho3hbVQA66kgaRPICd5P3ns0sjIpW1bonjdpnqH0e3KR8UjdVA6unB40FmshTECkPGpBfISjYTkBYOxvB6t2QG3XoVcQOtQ6SjbLA5CAtFNSPpkYnmJUOIhLC8OnAuFzu3pjeEN25USTYkcikfqyNLRthQ2EwFETwn2ZbeWAU/vlb44EAyFgnt6q6sjeJu1FkIpEZbAraeidGFcSkrBDDZTQBERkPIBr8qJeMN7B0JjY6Enepubw7wMg1ZqR7yqVlQ80OHSRdqmshVSWJDC+BZmpfL4OWqFUyjyAG/n+MTE+JMPlJZWh6tnyJUSHnhwFeocPnpmk2ldQZg2m51QxIICXEB8/2Xx+Cq1YlW+SE9Ydu+88e67N2J4q3OlhXqRcJVCreJTl3YKLh22zWY7WEgWkPKpZFWYN7x765VPPrmya2Pp2tJoXpEof1WVTEVd2ilU6TDuS+wGA0kfvr6ZWby0csSDJ3f31vOjo+fv37g2gpfB8MrTePjS4tqRODziNPZCAykf/P9lLkzNKxdULoZ7zxzmNUfyltK8VLp4Yd00toOByEdd3oVZfMRbdAuetWjR4kpBOZ8pXgHSkbg5rCbCx5RveY54yeJFRV50cW/GXVzDCoqXszyyeKQODTmTtTBAdP+R5YvgSeHR+HQUHo2o6gGvcdmixUvEJA/poHjoymLdTHaDfKh+TPmSKZ67ULp35+WPPp5g/liqD8fykiOLx4WO9qHyRfOKgDcQmvjwMsM7+oejwKtZsTQ9ljeV5s3kgDdnGnn3RfOWNS41/f1saHyMeamdevlPxz6Dh69tRPG+8T/nVry5iJcuzX34H2c/CH8SbNn22slrDG/u/4+Hq5e+NLfmxJv/eZ353tuy7f39J0/ULLiD6nF/7wFvQU3GtTffiOCNXN1/8uFJvffm0LwZ8ffeCkPG6RO//y3Jq67u3RMMXd3/51eltoRPLhc+Wgc88rXG/O9RvPn7jh/FvObm3ifGxsev7v+j2Rb9v0e/NKZx87cc9beHeeilVmQleUmH8XNbXVr6wJOXP5wYv7rzVas7zGPKx+VLjXlphN+5wMtdjXhUswHxJj7+6MbYzvus+rh37gxO*4.2pximRn6xkB9URYVRvOa1azfuujL66fnriCdCvLzwFwvpm83B9xSpm5HCFI9H86SRvFLg3X9+9OY741vvK/TQ33v4W5n2cfg1Sl3aleGvZcwrjuWNvnMZePrw1zL9PVrA4bd8SkrsWkMo0t+Ch6oXs9aYVVBArYRYXAeRizV6JTQ9aqVGSHMNn8mLWKlR1xcKyMk6klroTqcuLVqGV8EyXGmXag0Z8Ty497ywznWidS65Cqd9aIOA9VV4xDYBuUugkonRLoGSsGg3R1dv15WbN9GTS+4StDJ7GMmTsIexktnDQHssaAtoWNtTHP2/B8veK2MUTy6WqWJ2gLjZAIreASI30Fw6o8McxxufmLgcGkA8TYlcoM5WRe+fcbV9FrF/Rm4/4s3belN3mIffuaGxsbHgwF5CqdOQG2iML7wzyv7m40pculRKB7cePLhua6BtsD+CR36xhEIjA3vtiEduP2IfBcT3INvBO6Nk6Sgd2ruVeLw+rb9/e5iXlNS751woGLr02I8JtPNdqxDIsI/c+U7lcOc7i9z5VqmwTu5EO992i6muPYq3ZdulYDAIPHLzFvU0ZGoQor5BHp+7tsFyfhruG8gABzpcPLi2HS1NsTy0FX7v0wGbm2xr4KZLuOvCUdOF7rqIcU+jpALuPCP869XtaFofyTt19wjJQy0rF2oK1crpnhXXLSuqZ1XrrMjXiFDLCorXNxTFO0Lzhh02j8SF2pCT3vATalwSt9IaMJugeA0bLkTw1lC8hzp9BOqWulwaTXy7lNVuaUy71OUSoW6pN2DW+rvaG9Zd2HQwnveUqV5K2JRu1PqVUN1mTnvNuNmMus06t1tptBI+0LUcalh3etP3D8TznvOb6n0OplGvj27Vs9mpj2zV40a9zea1z7O0mWjdj5LieA8+2uI3dQ77Ag7CThAEeQgBHXRo5OKgQzp90AEmszscAZ+lTdtR1xWvC/P6utAhEXRGxBJ5TIS7UyL0MRFzfRs6JNKyoz1eR/MeeeZZ8PkHwwdsJueMDZrPNOgHXF9TAh3De37oJfJ8Ejox1EMfIDJwdEKphjkDBZPh80lNQ+iZjdVRvOC/fnlPbL7FXu45lvDIF3WSrLgYHSxbvyGBjuHd9d7bXOW9t//9yrXbn59LpEM8+CQIXryjk4lfNFf3v3Ls9ucPDx6IP/L40xfwccMznObc+6/9bl/zFznTeeRn35yMvP7C8cOfl/ZfLn6R+5JXD54AAAAASUVORK5CYII=)
    no-repeat 0 0;
  background-size: 21.07 * 4.2px 9.33 * 4.2px;
  color: #ffffff;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content {
  width: 100%;
  min-height: 38.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .nickname-update-box {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 13.33 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .nickname-update-box
  .input-box {
  width: 58.67 * 4.2px;
  height: 13.87 * 4.2px;
  line-height: 13.87 * 4.2px;
  background: url("../../assets/images/realNameBtn.png") no-repeat 0 0;
  background-size: 58.67 * 4.2px 13.87 * 4.2px;
  margin: 0 auto;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .avatar-list-wrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 11.33 * 4.2px;
  padding-top: 4 * 4.2px;
  padding-bottom: 2.67 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAc8AAAEBCAMAAAApRN7dAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAGMUExURTA2bjA1bzA2bDMzZjA1bzE3bTA2bgAAAC9MlytGkDE0bC41bjA3cCtHnC81bzA2byQ3bSxChzA1bi81bitGjyxFiy04dy40bC81bjE2cTA0bixEiSxEii84dC81bS82by44bypEjCtHjipFkCtGjiRJki82bzE1cFVVVS40bypKiitGjoCAgAAAgC82cC81aytHjytGjgAA/y1Lli82by41bi81cS81by80bTA1cC42bTE2bS80bS01cS81bSQkbTI4cDA2bipGjyxJijE0b1VVqhw5ji1HjzNEmSxIjy5GiytGjitGjy81by5IkCtGjyRJkitFjypVgCxJkitGjyxGjitGjzAwcCxDiDA0bytGji8+fC82bixChytEjDlVjitEjCxDiCxDiSxFizA4cTBQjytFjSxBiCw7di45dCxGjy82bi81bTA0bi45dTA3ciRJbSxDiCtDiixChi83cyxDiQCAgCxEiitFizNHjytGjyhDlCtFjCtGkDMzcC1LhyxGkCtHjy1JkitGj4h/mwYAAACDdFJOU4A1UAVqfnsAG9pJeYYSflUO0Dp4/t5JTn00a8/ejXxMN9gkVZUHd2kDThj3AgJyK/2sARFxSCtzMTA9LzYifgcpdq8jUwMJRA+SC7P4fCf0DlkGI92RVBDLRflSUdHcCejStOOFENnPRY/8aFJPkIYHz9/Kc9IC1eEZyRPbvhkRV8o/kxH4swAABpZJREFUeNrt3WdTE1EUgOELS1wrYIhAQu9FUSDYld5777333sHKHzeb3kbBUTEn7/sBmYyTmXueIdldwl2lh8l+fk9Qgz2dT406ewYlLevcHo5OhX*4.2px+OyuoLo7LFdGlo5uScs6O762p7BKK8odnOUVpVGw1jCeM0uPArqw*4.2pxoAjXzOSvtFIMzSzDU8d1fnp5dzHF0+cXd6chjnrshW+MBXoa3I84Dj27i/mG1jcyv2hk2OjRjraW41QOuv6g3O1mbjoZGxyZs+WezW5obtDy0mcIjG6HwP/GyOhyenbpFLwydneXp+dfdXnlry3vrs1Mpjv44OdtStZ7p5XQmJut7U0pbrWFbDpwbH19y2liZdT0zo+o1nM936CHYOjvxZVqZm1/eStZ97aslplv21h4Etqsgs3gBtz8s3QL8YnPl57QZnfISuZzHIZW3fkhYMqkI40zOUlJygBS5QJ2dBJHOGlpEeAqoEcwaCyuMMB6okc/pAB/QBgZxhQJVoTg/o8ND3oWGBnKGgPk9tYk4epxu0v+9bX79ETifo3IQW6qmZR8cXtpWSCdr7tVcmp1LbC+OjZi3YUzMnKaE5QXWpnM6SvKBKPKcHVDCnH6iSz+kCFc3pA1VRwOkAbfzcGC97iW5QFQ2cSlVXVUtfogtURQVnVOQEVXCKAlU1cAoCrVG1dcxBTHW1KiaTMYgpM0bF3GEMYrqDJ56EJ+FJeOKJJ56EJ+FJeOLJGPAkPAlPwhNPwpP+T08rnoI8rSobT0Ge2SorlTGIKTVLlZgYg5hMJSoFT0GeKfx8Cvv55P1T1vsnx7eyjm85/5R1/sn1IUmeXO/Dk/AkPAlPPPHEk/AkPAnPaPfk+q0kTz4/JMuTzw+Jis8PycpUgqcwT15vZb3ecjwk63iI8xVZ5ytcT5DkyfUhPAlPwpPwxBNPPAlPwpPwxJMx4El4Ep6EJ56EJ+FJeBKeeBKehCfhSXjiSXjS/+f5AU9Bnh+UNZMxiCnTqj5WMQYxVX1UxS+eMwchPX9RrPQyQM*4.2pxlulK18te*4.2pxYWAnr9qkw3PPXidxwTCTgWelesuzwr33POIuBc5X2l2/PZWzwFeL595vF8g6cAzzcez2Iz758C3j/NnvdP7SV7hEV+qS81j+d99vCL/Ez38cST8CQ8CU888cST8CQ8CU888cST8CQ8CU888cST8CQ8CU888cST8CQ8CU888cST8CQ8CU88CU/Ck/AkPPEkPAlP+uue7D8kIN/+Q+wPJiHf/mDs3ych3/597K8pwtO7vyb734rw9O5/y/7UIt4/PftTs3+8jNz7x3N/Byk57+/A/VckgRZzfyRJVX3k/mWijoms3F9Q1DnLB+7/KcqT+7niSXgSnoQnnnjiSXgSnoQnnowBT8KT8CQ88SQ8CU/Ck/DEk/AkPAlPwhNPwpPwJDwJTzxJgqcVT0GeVpWNpyDPbJXF3ppySs1SJex9KydTiUrBU5BnCp54Ep6EJ+GJJ554Ep70Tzy5PiTJs4Trt5JKzeL3K5K6k83vP0V5Wvl8gihPPm+CJ+FJeBKeeOKJJ+FJeBKe0e7J9VtJnvz9iixP/n5FVKlZeArz5P*4.2px1ustx0Oyjoc4X+H8k/AkPAlPPBkDnoQn/RPPTMYgpswYVVvHGMRUV6tqzEnMQUhJ5hqla4CK4dR0pQMqiNPwjAbQ6qrqqOB0esoHjW/83BgfDZwuT+mg8QmJemJCfBRwuj1lgxqcumxQD6fHUzKoi1M0qJfT6+kAHR1f2JbK2fu1Vyro9sL4qJfT56lrE3OW9AyZnP193/r6ZYJmpFvmJrycfp66lpwmD9TJWTA89H1ouEAiqIMzLdnH6e8pEdTFmZc/oA/k5wkEDeYM8JQH6uHMdSwuVyBoCGegpzRQf06JoKGcQZ5O0P21h4EtRjJnu4vziwu0PZJBF4Nc1vZDOIM9HaB767NTK4/9OjrYuf21mG5el8HZ1NJmcDZ8ajBA21qaDNCu33i229+GdOfgyJ9lZWp2fS+YM8RT312dn17OcXT5xN3pyWGcuyJb4QNfhbYizwOOb+P+YraNza3YGzY5NmKsp7nV8aW0/qq+1PFva7Px0MjY5E2fLHZrc8P2hxYTOERjdL4HfjbHw5NTt8il4ZOzPD2/uqv/ylPXZ5YeBXRhr9Qju9KK8qvyitIIX0Wl/SIQZmkm9D8pXX4G55UA0OsU1vP47K6gujssV0aWjm5Jyzo7vran/fyeoAZ7Op8adfYMSlrWuT0c3Q91eGs6bTrREwAAAABJRU5ErkJggg==)
    no-repeat 8.93 * 4.2px 5.33 * 4.2px;
  background-size: 61.33 * 4.2px 34.27 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .avatar-list-wrap
  .avatar-item {
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  margin-right: 2.67 * 4.2px;
  margin-top: 4.53 * 4.2px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .avatar-list-wrap
  .avatar-item:after {
  content: "";
  display: block;
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAADYn/qyizzss/Wl05jQm/jgp/3eC5khH9KCJ2qCN4cqZvDQj/lZo6Dwx/Tgq/jQk/kEy/l9N9Es09pKn9a+dwDos/1BC9DYm/09E/eeWuaiavUtN8Dsy+Tgo/jwy/k059Wpl4UZO7E5X9lBA9jYr+JiXvU9C+Dcm/7eQpYaT9oBW47B+v4qZ1XNy6m1X3nFa4p2x+uqYu01S/JGn+UIv9tqPwaZ+uY+Zyqar1jYk/2dk7eOTvDco/46i8pSn7Pq417WLpuui0bp9xmNZ80w6/Jym3jwy+4uc21E+9kw59DEj/62bwfyx14+j8kY097Z4znda2o6i5Gps+Hxa3sKTpc2Vq9yVsfKm1Y6XzYWCzZSWwY6UxrGewEhR8JeVvUdP86iStT075qKn2X5p5HBo6Kuo0beZtqyo1ZeG0VI/+aeNrUE8/Jiu+kEu+fq22taUstCPs0pH6vKo2EEz/Zqj3o2Q4KSZvbKOqLSfvE069J6z+jco/nNa2cyVr35W4uGUt6Oo2FJD80VJ8eKSvoyEzIuc2UNI7l9x6kJI8JWV35N6wkNF8nN197KSqo6c+qmOrJqt8beQp9qQueOUwZil4J2w+U9D/bOv0HJg26uQqrmkvZeP3FI7+I6g7sSSqsSNrdac4X6D1OaXw21g4p2Yvvas2a6iwHZy6YmW47GNr7+H41BO9JR0wK+pzktA/FdF8nN3/GN1/45p7Ec1+6Cn2nyI4KGWwamev/mpz0hG8YuX9YZg8Jh/zfCgxn6H6ZWp9L2QroRj5L2NoX6G2rKUsuiXxOmZw6eWtoib4qWVuEdD/ldH97qA2s2Z2smXuOarxMONzpJp65ur7p2t7a6JpDs946ms1YVd7VxS92ps/eSbz+yvz7WIx9Sgt5x8u9ykwPOy3PKjz5iu+pKAx31m0uuv11xD8eKoztegw6+Ipfaw3ZyXvOmdyfWu22ZX7*4.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)
    no-repeat 0 0;
  background-size: 12 * 4.2px 12 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .avatar-list-wrap
  .avatar-item.sel:after {
  content: "";
  display: block;
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAHrw/nD2/GP0/jP//3L1/nfw+nvx74T6/Xj5+3L2+3H2/Yn193P1/XH1+3D1/XH2/XH2/XH2/HL1/Hn+/4fp9IX094Xm+3D1/IL1+oHx85DZ/3v393T1+oX29nD1+3H1/HTv/5Tj/4Ho83b1+o3a93L1+nr1+3P3+YjY/nT1/nf0/4/g/3X4/Y/a+nL2+nb2/HL2/XD1/HL1/n72+nD1/XH1/pbl/4nZ+Hf194nw93f1/n7w/IXe8X/f9o3Z9oLv84Xr83f19HP1+3H1/HT1+nH1/HD1/Ifo9XT1/m/1+4D29ob1+Ina83z094rX+n3z+ZHg/37193zg/XD2/Yru93L1/nnw/43X/3Tx/47e/Y/e/3f1+4Dy8Yfk9H/x93T2+4nx95Da/3P1/nH2+X7x/Yb19ob19nXy/4Xi/37c94vZ/nL1/nj193309nL1/XL1/ILz9Ifn9Ibq83P2+4ja8oXw9nP1/n3o+In2+H31+nT1/ob19oT1+XPy/4Lh+4ja84fZ84/Y/47X/Xj193X2/XT1/ojl9Ive/3L2/IXq83D2/HTw/3Xv/4za/ojm9Yfg83b1+Xf2/X/083T1/Xv2+3X1/In2+H7t/HL1+4bZ8X/1+Xb2/YH1+Ibe8YXc74Xe8In1933j9n3b+4jY9X3b+onX+HX3/I3Y/4by9oHm/3L2+X*4.2px/4r294Xk9Inp9Yjo9HH1/YXj8of194f29nXt/ozY+XT2/4TZ8G/2+37w+Ynh8nz1+Yzt94f293T0/InY+Yfr95Ti/5Le/4T19Ibj8of19oXb8ofy94Lu8Xb194fx9nn1+Y*4.2px/3r1/Iff8oD0/HX0+Xvm+Ijm84nz9n71+ovX/ovX/4Tr8Iri83P2+Hve/IH19IH29Yno9Ijf9Ivc+47d/4Ts8pTh/4nZ8nr1/X329ory94n19ofp84fp8ojX+ID284Lu94bp84/Z+oXw84bj8Y/e+YLt9pHa/4L19IPb8Yrj84nw+Yrm9Jbk/4jd8obh8Yzu95Th/4zq9hQOKzwAAAD9dFJOUwARlwUBvgcEBQKIo/60jpx8rZSgDCj0Caf9nP0jR5NJgNniDETnS9hB/uHVuRP9VKfEkdbct7n5vR3ATe/++/v29yiNcmqxhP7RjG79/vrDFtD98atywtvK4g6H1c02+lHx982L8/5q2/35NxkwPU54x3rTb/ksyfL0z+e68O356b/w7TSxu8n+WKTK6d47MX9m3PXH4LiZ7ZzO5Kvvabnv7/39xPowO8/F9pPjy/3C99tvZbTz7YqDPvzz8vTGYIn++/zxvukii85Yj+V96sz2Xff0oNXHgs/4mPjBvexGmD+f9O7mc+HPqthcpv6v+MrP7/D//v///v////6J/QPtAAAIHElEQVRYw7WZf*4.2pxT5wGAjySXAGe+wcQKJQ4KNcwCCaFGwbpAEhKEoQ1BsGO0ILAhBlkgrCDaCqEMIh8GSoRqaxm60iFqmVNpsaWrG+1osWqn29Suart1218CdaLd+97lJFQYSbg9/wAJv+f35L334w4QZG4YAbWFL1+48DLBo9/hww9/DwFfCren+yGewVSduPDOV1/9muAdyA6cX+GscVJ9ISNH5JmZpTzx1pev/Zxk6WyeneHLNRmBLI/MQSfeem3JkoIND1g2MbEJZ5krG7659/aajGamZ80fLFmyYecrXYBYgoiLETixEbGx7e1dXTfHxoY+WfbN*4.2pxdBt6/b5kC8eWnXM3a0g13X3R0djWGYkADDoqO7u+vYHVbUrmsb+4To9nW7uRo0L223K8QYlybT+2u1EomERwC+02r1HBmNixkURt1Nwh3I9KQ51moAALmDJpBx9Pp8f0i+HmhlAhpXKOZrNOy4vHbCXeFGNzOosBqYd17swGh9VxzCK1f6+jj5+YQYlwMSOfAtR59AqIlp30p0LzgHWapCeAV3XqzjYonjwSHhIcHBYWFhj88GvALeCg6L4nH5xrat9769ejSjYoE5KCKb62h6jjqISUJn0knAD3Ty5W3hpQKxNSL+3W/fPrpANyuwEF7Bnc93CwTaBtXCn1EZUkrDoPvOAt1E8wZglmklw0FurDI/pamUI+yIBO6Bo8fn7wbN+Dg/H83RS6KC3NobmMpwngy6k+9c/d3x+da8CIzG+wUF0CwpbQhiubsKTEl6Lhu4pz4FbubczSnVH+DmRH9JrtLtfQFcSx7HAdz9U6D73BxFzIrC6qUFBa8AszYpSsXyZC/LTcoH7s7+adjt+/D7hbAZN3vSTHSbJImE+9WHu5kVKXCc*4.2pxgmukxJiWC8K/unzxw8MPtasoJS/kKaJVFKuodHEkLfZuLBa1k5DboPKF3crIqUv75fMAHMHH/Pm4m28CSO0CqvnE541bXbFzZPAHM3RysZVXphBm7QzcHi5JUJ0E2ON96Mm2WcUq+ayW4BhhYRbrybIQLN+4D5Yp1Aqx1XemkmumVi1FaZMAm7mQzEp+QWbB4Cex1NMqpiIl4D9yoH3yKtTEjdffBArw+yHW8eimBz9f6tQSxkEbDAuqSxG5vOT4Lu49eQW//sAuZ2q1DIGVeJkEXBUgbzMFTedD5hcvfBs8gjP9o3kdZu53NlahULWSR+oBuLOVZzaLJ89wtQ*4.2pxlIp2ALW1WhyKKhbwuW8POqBtel3tiPq8csBkdpCR2hAL/0ED3MTr3RgzyyY9+mjyxidUUoQgmsbWoUqOGAPLpjX9pHedhaEUIRzCiFq9ouNIVSp9bIqw6lwsu4Y31au9FhCqBObdA1rXsKnyHr09pQ2lrq1LnivCxC/Yf1aRFWWTh1ahNmmaUOoVAtjLHNqDs4FKrDuUagfsypZidSqy56oH6m7mQwhWoHCtWrCTX7ZDB18zqEBtRPkOq6k2GUqlfMqDUUq12r/Sl*4.2pxzMJ9Z/W/5h69S5C/QPK1WjmrhGg/tv/Wa2hfEBGvvd9Qs2mUh0Oq997oKZy8oHVOKMGe0gwpXuIU/0zoKZ05wObauauJ4H6F7i6j1K1PfMnpLrN2hdO3ViDU+bNGTV6ZS11anA2uqhjHLmUnugzaqldSKG6QSPvJNWnpZboKArViiJSPXD6po4/Spla1BAnjX+gHpNrRqm652Okq2Nc1cfYoxTNEIbPKf/Gqq24+u//GPjXkBTl1VIyIn6rTpXydU41qH73dFWehkfFrTsDmMWNbfFvvATVZf++mpy8Varjmxff7Zd+KgmzS4H5/hcbryPXyuoHoNtoWPQjBxiNJC54AHvjpf+8t/H6ASQ9p+zop3eS49vyxOoS0SKbzTSF7k1gfnLjlmuBiJ8oMKN+ALiLrJhZRV9Us1nAtjjNe33gk6JvM+ieSo6PNNJaS5jeN29X9/EtNnw0tnye7VyagWX1cEwiFZja24d01qrtKYkGY+bTRHM2g1z2YLwvTyV3RqKC1hJfL5tbE8XQfN+lmfjTU1n9mak7nZFxoFvkXbNejELzFxu3FM9a2aE5ZfWXcbdA7fkchM35GLri6ZX3R2Y3493NsHuqUxcnVqsCvBhnMTSPwOaHPjXR3Q+7zbV0j8cZb749Aq/gw8uf2dwCuvs7dVbwwB7gSfNhZ/Pt5+ZqhmTntNRfvgvcbMetWqb7O9LhVqd5+ZG5monunJaPz9yd7tQZDeaSALebzTKDEW8+8tleEWOegOzmlo/L7/ZXgjnIc68bNIM1SJqLfRjz/iLRndCps/CT3NljgdlMY1tsCzQT8wTvTqgsQg28hfcThs9hs0NBmouzGf/7qM9xuvMMC3aDMyUJQ3VZ0Lz5s2IRY4GS0N6W/eV3Jyuz7BpebWjAqlU+85GtfBycVvKsP+PNvdlu3Efk/HZ/eerk+Sy5RjI8PDze0BCVm5trMq0lMeVGRTU0jA8Pm/35jdImaN78x2K3dh5RL+FukjeiCo1BjAkdNJpA0CfD6RMIaA4hJjZoFGijnDT3unmvISom3DVV0mNyXZ4lxoiicQAFAHxBUWNMY55OfkxaVTPobHb7LkbUjLsPDdbUNDVlZWXZbCtcsdls4MWmpsHBwddX3n4RNHtwfoTuxd2T63B++h1+ifM6ZOXy5y550ExeyxvlT5E8McPy2ezxrBnfq66d7dl94zGC35DsIXnRyZ5LZz/P9vRIOvf19Z6eFwCrV6/uAfzQlUs4mzcfuXT963Pz/Yv+v2X703PppdVZAAAAAElFTkSuQmCC)
    no-repeat 0 0;
  background-size: 12 * 4.2px 12 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .avatar-list-wrap
  .avatar-item
  img {
  width: 11.47 * 4.2px;
  height: 11.47 * 4.2px;
  -webkit-border-radius: 5.73 * 4.2px;
  border-radius: 5.73 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .update-content
  .opt-content
  .avatar-list-wrap
  .add-btn {
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAKmYvLWwzm9Sz3hW2c6YvY6i8qSf3Kai0K+au5eYv5yx+eaVuzImyqqq1JyZvpCl97iSpFpYx0Ex9NSdzI6b0ams1pKn99Saq5aV*4.2px1d3qygviceyp6Jy9+Ru7t9y4iGyuOUwZmm4j4x2O+u2ceWo7iivLSLqI2Vymxr3Jih17eXsv281uKXsZuv+ayNrUUy+IRg7cmOscSEwueYxqOo2ZKYyIGI1I2c1rKbu6qo0aiWtJOJyZir6bOfvjwt4n1W44qZ2J+z+iMrfpGg+bKPqV9e3IKR5b6OrpSp88CPpcmTrCsg2bWEt25R32Jj6aGXxn+J4q+Kpmpu7oqc5qiNrPWq2Hpg1WtZ4y8i+YeW8fq228aL3isf99aWvOKUtysmuOyezKSavo+c05Om4WlV1I6h4oye56qCs/Wpyt6i30w59DYm+/Sp2OWVvqiRrTkt0KecvyQcyUY34iEdv+ycvrKOppp5v/yw19KSr9uUs/Oq2ioh1eCUv7yFu5uk1eiWxJmp56eYvcuYu++y0beSpzEm5O2gyWBf1KSUtqKUvSQphi0i5tGct+Cnw+SrvCcnnOa*4.2pxe+fyiYrkB0laSsptBAaRjEu0zMu35pq5KSo1nuC+o2D0IaT2AwXPQ0YQMer9g0YQsyr8vCr2BAcRc+r8NKr7sqr9PKr1uqr3Dcxvuer3hskaRIcUeOr4SAjjyIcrpV+uRYZeSMdsxYfSCMgqeyr2x8Zn4V4tiMmd9ar6yIhmRgkViAbpyYguBsfdu6r2TowyBkjYiMkoToyxLqGrx0lb2Vk0BEbSp2y+Sckrp54pfSr1Twxzh8Wuh8qeCslpsWr9yIsbTUwtaKDuSstV42U3ot7umZUxyQbvxgXra6RqryovCgiwa1/qbKDrrOmwJqv8+yZtycviVhc1Sw1oZeZ3X5lkyYslzYmy0I+ai82q7aMw/6y1JN3qtyo4CoyndOg166HvGtdkF9Uhb2a11JJdrySysiY0JaQ1C01kLSLqYpvn8qk5JCc7URCyrLXCqwAAADydFJOUwAp/PzjCicDBzTS8fv4wPdo/PzQD830uP2l3/r+78r3/H+U/bn8+MKe/v38+v2badvvxPw3kPf89H5x/v3+yd/pnMv+/s79/r7t6Ore+vLmHfmI9m+60Pvlu/3i99DD8f2IedX+6fe//vz96t4+z/HxxO319/zt9vjt7o39/vnMK8xvvOPq8/3ywELpx+bm/es90bLuyuefhveL8/T0///////////////////////////////////////////////////////////////////////////////////////////////////////////////+wj4AHgAAB7BJREFUWMOl2XtUk3Ucx/EJ4aAwI8jITckWmplBpWUiTSMza6FohZQUmpqEFSFoFyy7eUFLTe1+mBNRuW40JhlsNZiXZkNEUZfNSMoZGYRXMu30/f1+z/Ns043f79k+/3jEc17nfX48zzO3SSQ+FtX7ujtdu8VjI2FfoI38YnTBZKlE3EJBflDYO2jPk72Ndi2/kaPDQsXJ0t7X3TjxGmGJiYmzbndbP9euHd1LKla+5ocfHuL2H+ygsOMHj/O7HdtiuqWTifzlVLSheLs8Rn42NOV4vyDUHSqy+empWQqb2WwpRduP9ud+bqWlFovFbFPMH3qwX1AQezfX/PRUhbyxUa/TGY01njPCdDq9yS7PVzz8TxCy2br55odtdrvdlGGyWq2GBvcZDAb4WUaGw+GQy3k7TMp01RHZbNJZ/4T9Dvv7BOxv+JMM/Qj9k9VqctiYu4Vmi76xKal5J1n5ZeN+vPO7Wr3DtouzpYzNFp2xqa1Oo9ao3abx/JtaXfFdrc5uRnYr2CHUOwXJpTpdw946TSFl2DaZd40JCpK9+m5P3ah54q+/IrmmNqlOXVjIYhtMlsNjWluRHdpjM8i/lRqMtQzNaBrcLdjSnptBrgFZXcg01G3Ugy1rlS330c01TyDNFYwy6TZgW5aw3Gt3qEuu0TI3c91ao770cFVCQsLyuCu73ZprGvZWaApFjO8G+5XlcZe/NIT2fuKFiYmJ+DTENfPdBug+BPaTcZ5nInXJqFmkzF+D+EzAdu+WBtQsdMM1eCjhiEc3Oo05ATS73ztVR464dUuxPCvlt1KdsdavZt62Cjbpxs2zZkGzrqYhqcJPmet2mPnuUCn8fwPLKdwTyW+Z2PCMBTtiAXRHSQqQPCdlUh+9saEtENndPgJ2geSJcaPmgKxshCd/3abCwkBtk1wRvBDZUyTjbhh1MGVSZI6+KcBmwc5XzEZnMkQy7vlRE6ZGquT723pudu7g5+zZbnDkz0+dG7FgPKpG0dYL9T03H/0Rb+*4.2pxrXso3Yb8JckHIj4YwtG5bbRzPkpcGg22Vu5OKzO20551R4lbVFS0h/Ic/FqucKPnZ2zfxEIDXPQ9lbYrgnn6vknZTHQRlhloW/DcWJ62WZno72HbtlFpk+3w3NhHCb3MbN1JpYuwu62khJF+RHIbpg10GsElJSVlZSLoe+9bZmkqp9NILitjoPXmw6diHyP09ZYmejVJLqvsdLLQ0S66mUbvQXBlZWXnqXZRdKl3+uI*4.2pxo52lXHyuZaWMx0HuDn9pXegexsuZe6UQe46cK66/eLZb/lV+aBPRn/4HgMNlwZ3GJVdHeda3GXvtI6JRs2C3NnV0d7S3gHyZn4+6GBCX33vzT5pVzPQnd0X2+vOVV3i4OLi4s3FPulVVJocNGnudra3gEzU4uKNGzcW+6TPr/qIQmOZ0J3nnXBpHLiE4Y38vNJWTD9LoYWD7jx/GuRTlzh4CzdfdDcbjeWTIJ8+iZI5eAPeIe8XX3B3JtA3Xd0X0V5v9B2CfOoMyOeJ7IJ90bbU7sz3b8X0Mov3J59zD15Hh7O9rsV5lpPPfuPaaR901x0cPdtCf6ie4eUt39Afqi66v4X+UtDByxvE0dnWvTS6CmgsM9CK1BfF0RCNf38M9F0v3vEMRysz6DRc0FvYaIc7HclCw3Gg620fnZ4v0GP6R+YksdL76LTcg15Jp8nvkInOch3ItPi0FRo2eh+V3q3Nd9FjgF5bTaW5aAq9u9y4xI1OjU/7dN0mFnofhVbvLq/NnZf1eRlHQ3Zk2nrKf91PH+J3pqfmeq19Sfxd04sQPfOmvrK+X02LX7m6PsA3Sai5XmuCk56+7a/XnnpTUjDzVZlMBt2qE/WBvk0CWQ9X3vQiJA+STA4Du1U2YFpkjrZeE5BcUa7VIflHJL+0WCIN6YXs1gH9lbnagN7s7kaygpej0Lv0UNT9M7L1AXSrK5rbDHbF2Olbicx9aNFr5gODkZ3dqK3T+NvcfMFg/yOZbxY+EAnj7D46bb3a7+bGP4Jx8wyXzHf/PGB2H5PWnzfq6urmC0YkZ/6V+dSMER4froaE3Y+7Z/vVjZqRHLM0M/Njj2ZyJvdz3XbR3ficBXnEFR8Ik+7BfnSDjM85ZtHSpVc2X9bdJuaeh+uZNOfl5Xlrxl9NCd0mMfc83CmkOS/v5Rlronx8FMzb2Q4taze6B+F6Do4JB3nQCJ8fvOPuwcMG9FflsnbDE0kH78ljFh0LBznK9+fuqHvYMLCVOWzd5LlxVUw4ktf09GWBFK6T8diOVK1m6AZZL1eO5ZspX3EQeyG8yK9fV02VT+Sq4seS5hEhtC9muO6F8Jr26dpPPqn2vU1161ar0gU5iuHrpLAp4yMi/l0IL/OffbZ2xYqkpO1elpTUtmL1+jROHsjQTLp5Oz0tLW2lKidXr//JY/rG3NwcVXp6+jxeXhzC9tUdbydnzZsXHwlTKlXZfVzLVim*4.2pxMKy8G+QtdndTk1Ovsr7xqIlJ39O5MUh7F+TcvYvc2GPC3sL7x73LQoX1czbCyJi+UXHRnMbHj2cX/jwY8eOPSeuGd/zBVOGLHiU7DG818neIHuO28BBa6IkIr/t7hU3ZQjeI7C73fcs2kBuM+IW+3pu/A+BFhCKl64FWgAAAABJRU5ErkJggg==)
    no-repeat 0 0;
  background-size: 12 * 4.2px 12 * 4.2px;
  float: left;
  margin-right: 2.67 * 4.2px;
  margin-top: 4.53 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .user-avatar {
  width: 39.33 * 4.2px;
  height: 23.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  margin-top: -8 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .user-avatar:after {
  content: "";
  display: block;
  width: 38.13 * 4.2px;
  height: 16.8 * 4.2px;
  background: url("../../assets/images/avatar_outer_box2.png") no-repeat 0 0;
  background-size: 38.13 * 4.2px 16.8 * 4.2px;
  position: absolute;
  left: 0.53 * 4.2px;
  top: 1.6 * 4.2px;
}

.user-index
  .update-avatar-nickname-dialog.common-small-dialog-wrap
  .user-avatar
  img {
  width: 17.07 * 4.2px;
  height: 14.67 * 4.2px;
  position: relative;
  -o-object-fit: cover;
  object-fit: cover;
  z-index: 1;
  -webkit-clip-path: polygon(
    73% 0,
    99% 51%,
    74% 100%,
    26% 100%,
    1% 51%,
    28% 0%
  );
  clip-path: polygon(73% 0, 99% 51%, 74% 100%, 26% 100%, 1% 51%, 28% 0%);
}

.user-index .bind-invite-code-dialog .bind-invite-code-content {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 17.6 * 4.2px;
  padding-bottom: 7.87 * 4.2px;
}

.user-index .bind-invite-code-dialog .bind-invite-code-content .code-input-box {
  width: 59.2 * 4.2px;
  height: 8 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbwAAAA8CAMAAAAqqf+BAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACcUExURTdGtDZFtjVFtjZFtTZFtTVFtTZGtTZHuDVGtQAAADlHuDZFtDVFtjZDszZGtjVGtEBAvzdHtTZItzVFtTZFtDVFtTRFtTVFtTlVqjdEsjZHtDZFtzVFtjlCszVFtDZGtTVFtTVGtjVFtTZFtTVFtTZIszZFtDVFtTlHszZFtTVGtTRFtTVEtDE9tjVFtTZEtDVEtTVGtTVFtjVFtRWJUrkAAAAzdFJOUzP3P6I08YA9bgASk/Q5QjoITzn69qlrbwk8PVGMG+zC+6j5mPY5nPQ2p*4.2pxN8hX1e3jmgUXS8QcAAAFoSURBVHja7d3JboJgFIbhg7YFQX+RUZzneeb+760hjYZ0*4.2pxyT9qTvu3J9ng0bv18a946rxWQWRbvDa4WuF4ee7nKtcuvDLopmk8Xq+CCT+w/XO+XheBpv929f73Y2Nj2dOd8qHHu/jafjMD957mc812vmVt0EwXLzUiWhb1Tp1JtlEJi6lTcfelK2q3HOv16trCfY6dUT7PTqFXjDuYWdLj1rPvzA8wejcB0brqIlE6/D0cAv8Px2p8VBtNXqtP2GdLHTqteVXh87nXr9niR8qGj9cEkkzTiDzrJUHJsz6Mx2wAOPwCPwwCPwCDwCDzwCj8ADj8Aj8Ag88Ag8Ao/AA4/AI/DAI/AIPAIPPAKPwCPwwCPwCLz/hcffmrWWpQwKqK2WMOWhtWLKgxEdpXbFiA7zVVrtfIbjFFYajmOyUduHSnmykbFUdXalsVT0dNoxEK7Yjmn+X+1npvl5FEPzoxg8R6PwOZp3w9*4.2pxzSRyOaAAAAAASUVORK5CYII=)
    no-repeat 0 0;
  background-size: 59.2 * 4.2px 8 * 4.2px;
  margin: 0 auto;
}

.user-index
  .bind-invite-code-dialog
  .bind-invite-code-content
  .code-input-box
  input {
  width: 100%;
  height: 7.6 * 4.2px;
  text-align: center;
  background: transparent;
  font-size: 3.33 * 4.2px;
}

.user-index
  .bind-invite-code-dialog
  .bind-invite-code-content
  .code-input-box
  input::-webkit-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.user-index
  .bind-invite-code-dialog
  .bind-invite-code-content
  .code-input-box
  input::-moz-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.user-index
  .bind-invite-code-dialog
  .bind-invite-code-content
  .code-input-box
  input::-ms-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.user-index
  .bind-invite-code-dialog
  .bind-invite-code-content
  .code-input-box
  input::placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.user-index .bind-invite-code-dialog .bind-invite-code-content .input-tip {
  width: 100%;
  height: 6.67 * 4.2px;
  line-height: 6.67 * 4.2px;
  font-size: 2.67 * 4.2px;
  color: #48598f;
  text-align: center;
  margin-top: 1.33 * 4.2px;
}

.user-index .bind-invite-code-dialog .bottom-btn-wrap {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 7.73 * 4.2px;
}

.user-index .bind-invite-code-dialog .bottom-btn-wrap .tip-text {
  color: #48598f;
  font-size: 2.67 * 4.2px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
}

.bottom-btn-wrap {
  width: 100%;
  height: auto;
  padding-bottom: 9.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.user-index .logout-confirm-dialog .logout-confirm-content {
  width: 100%;
  padding-top: 22 * 4.2px;
  padding-bottom: 18.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 4.4 * 4.2px;
  color: #a6bbff;
}

.user-index .logout-confirm-dialog .bottom-btn-wrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 9.2 * 4.2px;
}

.user-index .logout-confirm-dialog .bottom-btn-wrap .btn {
  width: 35.73 * 4.2px;
  height: 8 * 4.2px;
  background: url("../../assets/images/logout_btn.png") no-repeat 0 0;
  background-size: 35.73 * 4.2px 8 * 4.2px;
  line-height: 8 * 4.2px;
  text-align: center;
  font-size: 3.33 * 4.2px;
  color: #fffcfe;
}

.user-index .auth-real-qr-dialog .auth-real-qr-content {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 15.87 * 4.2px;
  padding-bottom: 9.07 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-index .auth-real-qr-dialog .auth-real-qr-content .qr-box {
  width: 44.67 * 4.2px;
  height: 44.67 * 4.2px;
  background: url("../../assets/images/pay_qr_outer_bg.png") no-repeat 0 0;
  background-size: 44.67 * 4.2px 44.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-index .auth-real-qr-dialog .auth-real-qr-content .qr-box .qr-img {
  width: 32.67 * 4.2px;
  height: 32.67 * 4.2px;
  border: 1px solid #70edff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-index .auth-real-qr-dialog .auth-real-qr-content .qr-box .qr-img img {
  width: 100% !important;
  height: 100% !important;
}

.user-index .auth-real-qr-dialog .auth-real-qr-content .bottom-text {
  font-size: 2.67 * 4.2px;
  color: #9ab2fc;
  margin-top: 12.8 * 4.2px;
}

.user-index .menu-content {
  width: -webkit-calc(100 * 4.2px - 5.33 * 4.2px);
  width: calc(100 * 4.2px - 5.33 * 4.2px);
  height: 100vh;
  padding-top: -webkit-calc(var(--head-height) * 2);
  padding-top: calc(var(--head-height) * 2);
}

.user-index .menu-content .action-list {
  width: 94.67 * 4.2px;
  height: 33.07 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsYAAAD4CAMAAADYWdBzAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAKUUExURQ4eVhs9qhUvgxEocv///xQxiRElbA4gWTpPjRcoYQ8jXw8maBc1lhMsfQ8jZBxAsh5CuRo6oxk5nRUzjxQpdw4fXB5FwClPyDtPjh5GwA4hXRQpeBc1kRk4nBk6oBo8pxo8pR9Gxh1DvDtOjTpOjRMufxQwhhMtgA8kZxElaRMsfBUvhRUvgBIqcxIqdBEocBUwhRYyixc0lBYyjBg5nBc1lBo7pxg4mxs+rhs9qxY3lxo7pRs+rBxCths9qhw/rxs/tBs/sxxBtx5Evh1BtB1Duh9IyyBJzR9HxiFJyx9GxCJM1TtOjztOjjtPjTpPkDtQkRIpdxYzkB1Cuh5Fwg4fWg8jYQ8kZRElbho8phg2mREnbRUvghs+rxUzkRQrdxxAtBMsehQreQ8kZhk6oxk5oRc1jxYzjhYxihw/sBc0kRxCtRg4mRYyjhg3lxk6pBk4nhc0kh5Fvx5Fwh5EwBk6nxg3mxk6oRg2lxk7oh9GxR1Duxs+rBo+rjpOjBssZiBHySBKzh1AtiFL0R5Ctx5Cuh5GvylPyR5HySBK0CBIzilQyR1DvB87nCFK0iBKzzpPjytU1yFK0ylQyR5GwixV2CBM1B9GxB05lCpT0x03jztPkB5FwyxV2x5EviNN1ypQyztPjytT0yBIyR5Fvhw2ix5HyCtS0SpRyx9GxSpRzitQzStSzipSzyJO2SJN2CtV3Bs1hRoygBoyfBkxdx49oRoudBcrZRcrbBcpYhgsZxgtbhcpZCxX3iJP2yJO3CRP3i1X4CFApyNQ4ixX4i1Y5ixa6CFDrSJDsiNGuDtQki1PwTtQkw4eWA8jYhEnbxs+qhg3mBk6oiBIyiFK0SJO2CNP3yRR5P///zFc6v///zxQj8EO5iUAAADbdFJOU4CrlIv3l4mB9o6Eh56RhbC1p6KbjoK6wvu7g46bo6Spp8C39/eRlpKGiJCUk4yNi5WYnZminqigraufqK2zrK+xsbS5sbbDxr/Evc349/b5+o6atryChIaJp6CKk62bj7CQj4empZuamK+cs6CZn6ajnbq9uaShpqClvbesrvOWwceyybW1u8LByMXCtqzKyPnOysO70My+qc2m+LzSuM7D+MvCuaLBycS+x8XFyNHQ1J+dmpiwlpCTj5KUj9fT1NfZtNrc3uG4vcL6yPqAhYqqn6TCyc/W3O7l+uMAhQgAAAusSURBVHja7dhlV9VZG4BxD3hgBhCOgc7pwHPo7u42KFtBQlGwBSV0bDAQLDBBBSRUwm5BEexu58s8e977+ln/0ev3Cfa617X2uvce92088B/3bdyP72OjTx49GGxtPnyyvbvv4uVLPeeOHqifBkhQ/YGj53ouXb7Y191+8nBz6+CDR09Gx77/GDd+7OvI8FD/2ZbGptT0ji5jb8aZY8q6qYAk1SmPncnoNXZ1pKc2Nbac7R8aHvk6Nn7c+NGRLw8HMo/s25+yN+14nrKzzdSQvEcBSNKe5AZTW6cy73ja3pT9+45kDjz8MjIqMn4y/PBz5q4d6dvTMpSJptzdCTuT4uKdAEmKj0vambA715SozEjbnr5jV+bnh8NPRMaPhgYyP6WmGGuUibWK6CSn2K1RW2LCZYAEhcdsidoa65QUrahNVNYYU1I/ZQ4MPRIZP+jP3JX60bhxg0lRHh8bFiPTh0QaDBMBCTIYIkP0spiw2PhyhWnDRuPH1F2Z/Q9ExoNnj+xIMeZVJCfErYyS6SPXVusq12knARKkXVepq14bqZdFrYxLSK7IM6bsOHJ2UGTc2rIv3bixIjd66ZJw*4.2pxGzTrsptGpNhAMgQRFrqkI3aXWbDfrwJUujcys2GtP3tbSKjJsb92+v2ZAc7RQmCynRBa2KCF5fplk+GZCg5Zqy9cERq4J0JSGyMKfo5A012/c3NouMDzelpClNCUvD3i1Ypg11CNDkrA5cIQckaUXg6hxNgEOodtmCd2FLE0zKtJSmwyLjk6l7MxIVcUtkCz4ELQzWlPrLLX6eVoAkefpZ5P6lmuCFQR8WyJbEKRIz9qaeFBm3p6cpa8tXhocsC3ofkB8o97PycjVPACTJ7Opl5ScPzA94H7QsJHxlea0yLb1dZNzdcTxRER+lL9EuDMjxt3h6mT2K1OopgASp1UUeZi9Pi39OwEJtiT4qXpF4vKNbZNzXlWeKjpUZdKHB+f6Wxa4eBdk+3taAJHn7ZBd4uC62+OcHh+oMsthoU15Xn8j4olGZmxSm3xzkoAm0LDYXqn2sfRfZAJK0yNfaR11oXmwJ1DgEbdaHJeUqjRdFxpd7O3c7xUTqVgWUyj1dC7O9fefbuNsDkuRuM9/XO7vQ1VNeGrBKFxnjtLuz97LI+FJGW0KsbK02QuPv5+Wh9n5r417sNs8RkKB5bsXuNm+91R5efv6aCO1aWWxCW8YlkXHPGdPOrfrqTcE5citzgY+vjb2b41w7QJLmOrrZ2/j6FJit5DnBm6r1W3eazvSIjM8da0iKCtGFrl9t8fLItp7v7vbGTqVSOQOSI8K0e+PmPt8628PLsnp9qC4kKqnh2DmR8VFlctyWyMqqskA/1yJxGRc72qmc59gCEjTHWWXnWCyu4yJXv8CyqsrILXHJyqMi4wN1e+JjDO*4.2pxaFZ4mtXei9zd5qqcGRekylk11819kbfa7LlCs2adISZ+T90BkXH9VIVTuEEbsVxuNUFtbWM/z041x/b1OECCXtvOUdnNs7exVk+wki+P0BrCnRRT60XG00TGsomTHCaLjKeIjMVOYWvLvCBNtrZiqxAZTxEZT3aYNFEmMp7204ydyRjSzdiZjEHGABkDZAyQMcgYIGOAjAEyBhkDZAyQMUDGIGOAjAEyBsgYZEzGIGOAjAEyBhmTMcgYIGOAjEHGZAwyBsgYIGOQMRmDjAEyBsgYZEzGIGOAjAEyBhmTMcgYIGOAjEHGZAwyBsgYIGOAjEHGABkDZAyQMcgYIGOAjAEyBhkDZAz83zJ++fzZ08c3Dp44deHK1WvXb967fffW/Tt/4rey7e+/JOfvbT876Z37t+7evnfz+rWrVy6cOnHwxuOnz56/FBm/epGVNXv2odPnZ8yYOXO6i8v06bNm/YHfi8s/EuTy06POmjX930pnzpwx4/zpQ7NnZ2W9eEXG+DUyZqnAL7BU8MQDPxUAGQNkDDImY5AxQMYAGYOMyRhkDJAxQMYgYzIGGQNkDJAxQMYgY4CMATIGyBhkDJAxQMYAGYOMATIGyBggY5Ax4wIZA2QMkDHImIxBxgAZA2QMMiZjkDFAxgAZg4zJGGQMkDFAxiBjMgYZA2QMkDHImIxBxgAZA2QMMiZjkDFAxgAZg4zJGGQMkDFAxgAZg4wBMgbIGCBjkDFAxgAZA2QMMgbIGCBjgIxBxmQMMgb+/xm/fP7s6eMbB0+cunDl6rXrN+/dvnvr/p0/8VvZ9vdfkvP3tp+d9M79W3dv37t5/drVKxdOnTh44/HTZ89fioxfvcjKmj370OnzM2bMnDndxWX69Fmz/sDvxeUfCXL56VFnzZr+b6UzZ86Ycf70odmzs7JevCJj/BoZs1TgF1gqeOKBnwqAjAEyBhmTMcgYIGOAjEHGZAwyBsgYIGOQMRmDjAEyBsgYIGOQMUDGABkDZAwyBsgYIGOAjEHGABkDZAyQMciYcYGMATIGyBhkTMYgY4CMATIGGZMxyBggY4CMQcZkDDIGyBggY5AxGYOMATIGyBhkTMYgY4CMATIGGZMxyBggY4CMQcZkDDIG/kMZq8gY0s1Y9dOM60XG4QZtxHKRsVpkPM9ONcf2NfOCFL22naOymycyVouMl0doDeEi43qR8YG6PfExhnVrNCs8zWrvRe5uc1ViqwCkyVk11819kbfa7LlCs2adISZ+T90BkfFRZXLclsjKqrJAP9ciH1+bYrFVOM9hXJCiOc5ipyi28fUpcvULLKuqjNwSl6w8KjI+d6whKSpEF7p+tcXLI9t6vrvbGzuVSuUMSI4I0+6Nm/t862wPL8vq9aG6kKikhmPnRMY9Z0w7t+qrNwXnyK3MBeI6tndznGsHSNJcRzd7cRkXmK3kOcGbqvVbd5rO9IiML2W0JcTK1mojNP5+Xh5q77c27sVu8xwBCZrnVuxu89Zb7eHl56+J0K6VxSa0Z*4.2pxSGV/u7dztFBOpWxVQKvd0Lcz29p1v424PSJK7zXxf7+xCV095acAqXWSM0+7O3ssi44tGZW5SmH5zkIMm0LLYXKj2sfZdZANI0iJfax91oXmxJVDjELRZH5aUqzReFBn3deWZomNlBl1ocL6/ZbGrR0G2j7c1IEnePtkFHq6LLf75waE6gyw22pTX1Scy7u44nqiIj9KXaBcG5PhbPL3MHkVq9RRAgtTqIg+zl6fFPydgobZEHxWvSDze0S0ybk9PU9aWrwwPWRb0PiA/UO5n5eVqngBIktnVy8pPHpgf8D5oWUj4yvJaZVp6u8j4ZOrejERF3BLZgg9BC4M1pf5yi5+nFSBJnn4WuX+pJnhh0IcFsiVxisSMvaknRcaHm1LSlKaEpWHvFizThjoEaHJWB66QA5K0InB1jibAIVS7bMG7sKUJJmVaStNhkXFz4/7tNRuSo53CZCEluqBVEcHryzTLJwMStFxTtj44YlWQriREFuYUnbyhZvv+xmaRcWvLvnTjxorc6KVLw*4.2pxGzTrtptCqNREOgARFrKkK3aTVbTbow5csjc6t2GhM39fSKjIePHtkR4oxryI5IW5llEwfubZaV7lOOwmQIO26Sl312ki9LGplXEJyRZ4xZceRs4Mi4wf9mbtSPxo3bjApyuNjw2Jk+pBIg2EiIEEGQ2SIXhYTFhtfrjBt2Gj8mLors/+ByPjR0EDmp9QUY40ysVYRneQUuzVqS0y4DJCg8JgtUVtjnZKiFbWJyhpjSuqnzIGhRyLjJ8MPP2fu2pG+PS1DmWjK3Z2wMyku3gmQpPi4pJ0Ju3NNicqMtO3pO3Zlfn44/ERkPDry5eFA5pF9+1P2ph3PU3a2mRqS9ygASdqT3GBq61TmHU/bm7J/35HMgYdfRkZFxmNfR4aH+s+2NDalpnd0GXszzhxT1k0FJKlOeexMRq+xqyM9tamx5Wz/0PDI17Hx4358Hxt98ujBYGvz4ZPt3X0XL1/qOXf0QP00QILqDxw913Pp8sW+7vaTh5tbBx88ejI69v3HuG/jgf+4b/8DO3vd0W6d58sAAAAASUVORK5CYII=)
    no-repeat 0 0;
  background-size: 94.67 * 4.2px 33.07 * 4.2px;
}

.user-index .menu-content .action-list .action-item {
  line-height: 10.93 * 4.2px;
  padding: 0 5.6 * 4.2px;
  text-align: right;
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.user-index .menu-content .action-list .action-item div {
  width: 19.73 * 4.2px;
  text-align: center;
}

.user-index .menu-content .action-list .action-item:hover {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA4CAMAAACBkfufAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAExc/01a/0Bg/0dZ/0BA/1NX/wAA/3+B/09P/0lk/09g/01d/0tb/1Nk/0pZ/05i/0ld/0tc/0te/0pc/0pc/0pc/0dY/0xe/0td/0pb/0xd/0tb/0tc/0pc/0xc/0tb/0tb/0pc/09c/01d/0pb/0pb/0tb/0pc/y5b/0lc/0dd/y5b/////0CA/0pg/0pc/0lc/0Vc/0pd/0Rc/0xe/0pa/zpb/y1b/0Bd/0lc/0pb/0pa/x262ktc/1Fe/01f/y5b/y1b/0tc/0ld/y9b/0Fc/0pe/0pc/xjE1iCz3Udb/0db/0dc/zFc/ytb/ztc/0hd/z1c/zBb/y9b/0Bc/yOv3h+22ziC8GBg/zJa/y1b/zlc/0hc/0Jc/z1c/zFb/0Jc/0Nc/zFb/zJb/zBc/z9c/0pd/yOu3x652h632yC03ENe/zZb/zRb/ytb/zNb/0tc/0pb/0xd/z1b/0B09kpd/0td/zp98Upc/0pb/yGx3TqA8Udj/TeE7yGx3klg/jhb/zpc/y5b/zNb/zNc/yxb/y1b/yxb/0hj/TBa/z9b/xy72Sxb/y9c/0lg/Uhc/0pd/0pc/0lg/Utc/0lf/j139Epd/zWI7jaG7iC13Ele/klb/0lg/i5c/y9c/zdb/zZc/yxb/zZc/zhc/zlc/0Zd/0Zg/zxc/0le/j9c/z9y9SKx3kBc/ytb/zx69Etd/zKQ6xy92TmB8T158ziD8Dx68z9b/zp88T179Edl+xnD10td/zSK7Tp/8Ddb/zlc/zdb/0Jv90By9y6Y5zt89T529h642iyb5h262RvA2EJs+D158yOv3h252hu+2Epe/0pg/Tx88kpd/iao4kpe/zOO7DKQ6kZj+zVd/0Vd/zld/zt98DGS6UVs9R272iye5j159UZk+zeG8DmC8TiB7x+220lf/Dx78zOM7ERv+Cue5Sqi4zqA8SC020Nu9jt/8UZn/URs+DiE7iWs4Cen4S+X5zx58yOu3zGS6T158iaq4Dt+8TaH7hjF1RjE1fpl2dIAAAD+dFJOUwBACQgNBAYBAgIHChEaBRQNIBBBKy0/Dyk3JB4ZIic1QxUyCyEcHy4zozxCpQEEGEQxRCNIFjBmqUxMPkH5VhMwras4Rp9Pclj+9RI1O429YU5dmKFT8vjBCJGvbEhKWpNRR4+LlVV37/n49hN9gsCEPVA6ZHZJZ7laUfO7g8P1gGljqIaIsrG1VJtZ7buccVNvdIZdg7R5yMb3fFR+s6d0gLlyaG8hQF9hVn3mWLelasD44a3St128tIv+VMq/h3lvPkJ8Y13csPH3ep7h7/SudbCq6GzL0Id8P4doczTihmRCh36A1VtmkHGzvqjscqF0bbLc18qY7NLf7cvN9NfI8AAABrxJREFUSMeV1ndcE3cUAHCOXCaEjEuODEgCSUhIwggQRpKCjEAEwpAwZO+lIBhQQBmKA/eqxb0H7londWtb7dLaVrv33ru143PX38XSogWF+/Pu8737/e6933vPxWWUi0ql0WhUl3FeVDrF1c2VQh+nIru5G5gGrit9nMrHOzVRrWCNx1Hpbj6i+EsFLVLROByV7soKFRbG6foipKFTx+qcKnVOQVpL/pa5au+pk+ljVDHeqRFbK1cWlaUVDKgVKSTaGBih1HPtaWFSvbSoIm6S75gcneS+R52hSwvjc5gcfkhpZIkvx/2hjk5K4fgO2EuLeUqunKvkhWT1HtJz3BkPdjSSO0dfYqkK44thCo0CK/kJi3X7J/hxH+iA8gsvsWdFTVDEuNKpYMGcCUV2/+zwBzoag+sXvt9iKRMKxFPlZBrdLUUpEBp1/okqsSeFNroSq7KX2xM1Ql8e+A9gn348vbA5M9ISNbqjMTzFqrLFlmoUmfHMU1cUMAXmXH7qmSIzlBi3PEqlHNkBpVSVZdkPocHWH7769INwFokV/vTVayuig6Hs2KxivhIewdEonmJ+VJVuPypr7zx6Y2mrwzDZEN+69MbRznYZVF1QVcQbwRE/mxdV6j8JlVlfv52LXz/gMJAMmgPXsSfOdVpl0KGFpeU8JuwRcL9i8opBKqGItfNcLn7m5y/VMYwY9XcvTsTq1q21IlDJwooQHpN9j6MT3ypPizyFaq0964C68/0iCTuQLVn0wh0cq1vfE41AkxZUhgiA+6++0D3YTF55ZWQLipzdvH4DPrH25ZnCIAaNYZDOPJ6DY/Vdm6PNUEZfJcIb5qiE0s6PjUDNmzZ2TcHxnLYVkJ8cZIlcjK4anAVc3sZNZmhu33xU4AWTqUPKS7B3XkEECq3sz0vG8VltSVoF8ZRKZnO0SSeTMSz3fH8HBEUcbmqWBN11VA+5l0DbFFcIQR0152fhePfsm8HesHMtwClkq9umYNiU0zXAFfY1aiRBcuKNgXCQYG9j3CUzULOBSs67GSzy9BhaCewdfHM2cMltNdMhaPeC7U7nQnP1kUCNcTtRx4ykthyguvoTgAr4d99waEJNXi6G5QwmGR2mbQsbNBIfVxc62+/NhtgGRB3/2Te1OD7lxJpMCXdYdKgenhLj2hPA1R551JGKNGx5wyZmuwRyRXOWbe+wqWwfHwShPfbS41IDY3hMAyg+0pmvHNuAYQc/2htuM15YNkfEJdiu9Lema1S2Tw5iWD1gQgNjeMugMljqma/80Y3h337xocqReXHZTok7WKTYtj29QZbqsB7JwbC6E2uMEs9hqUBsbkbPX90gLj/tc0ihbbHzQjhsUN98JJrG9J2obcaqx7rB9/L6E0KHQkqEAN4jS5rdjWPJeTVGjWlObK*4.2pxYHAD9+VBvOamabu1UMfqx8Cfrj+9OtibPZQKIODQqkGQYBu6Np41QxGR87U8pjzQ+T4vnmleeiFi7qg5CXae25YkU9x14JkfemuwFqj1m0E6t/SmJRDHjj6Uksj89F2IeWX/6*4.2pxMTz65wsyBA4nkgsWmWy/XTsTq14FDgGbEVZTzmfA/zTKAcLLK9BYE2bTxfD2GzxpcBYlhIpWVmseP/3kGqz/XCdSArqJ4+BEP8ACHNCRtWQaiPbs5rw644+DgkMDBUe878uoZrO72GqsMPaUrjeLfU4iAU/LL83ecQrTRPV3A3XkBHFOyXJT5G6Fee71dZlrSW0WUy3vKrLNuF1XtWILIrGvXP4JNfLFVyKKkqH/85Qz2yGtPPhqMVtuzylTK+4szUbhUYVmHD0HArXsCe/ZAM6hcjudBCfqdUNmWxdkq8f9LOnBKVfHyw9mQrL3n6HNLW21BgLUufe5XoEyJ/pZq1YiNwPk9o72vDAqOXnHtvbfDfUisCR9c/fr59gRTosVSPVr7oFG44vBM/wWZEJKw6J3LHJji6X3l/c+NMlPmYv8l+lGbI9Fw9GW62OkmqZ7vlzKZaMfvSuObjcvtzpZKH7XlgKaYvbV3erxAmeIWSAuUs8QCaVSpbsB3z+jqrvPdH+lfTPR5MpXoyKrifF2GWvHg9k0jpSjUS2ItYaAvMcgUkHQhFf5gOIl5yFDjdCULs8JAkOREys3rjUglFPVho8JUb/WkBVXlKg5TzNM2Re5KDWU9VAE3GbiBw/lhQr06pCmyUChiudGpYxmDWKHSjPT8jqLMxgKgfMakhty0/H0XtuyOB4o8xtkXlCVRfMS0rbHbbCKDnDzmifmu23FRIxmPAg4MvfoooWh8yjliBym9UuSBI6u/AcTpGABHGPMNAAAAAElFTkSuQmCC)
    no-repeat 6.27 * 4.2px 1.2 * 4.2px;
  background-size: 7.2 * 4.2px 7.47 * 4.2px;
}

.user-index .menu-content .action-list .action-item:hover div {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAAAuCAMAAAD5s8D1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAGMUExURQAA/yBg/yJV/y5d/zNm/yRJ/ypV/wCA/wBV/0BA/yhe/y1a/yJd/yZe/yhe/yZb/yRX/ypV/ydb/yZb/yVb/yVe/yZe/yRb/yRV/yZb/xpm/yZc/ydb/wAAACRb/yFZ/ydb/yhY/ypg/yZd/yVa/ydb/yVb/ylc/yZb/yNd/yZc/yZc/ydd/ydc/ydi/yde/yVd/yZc/xxV/yhc/yZZ/yZb/yVa/yZd/yZb/ydc/ydd/yVc/yZb/yVc/yVc/ydc/ydc/yhd/yZd/yZd/yZa/yNc/yVa/yZc/yZc/yZc/yla/ydb/yVa/yBg/ytV/ydd/ydi/yRb/yZa/yNh/ydc/yRZ/yla/ydc/ytc/yZg/yda/yZa/yZb/yZb/ydd/ydb/yZd/ydb/ydb/yZb/yda/yVa/yZb/yVa/yxk/yhg/ydZ/yVd/yRb/yRY/yhb/yZb/yhc/ydd/yha/ydb/yRb/yRZ/yha/yZZ/yZa/yZb/yZc/yZc/ydb/yZc/yZb/yZc/yZa/yZb/ydc/yZc/z/uhBcAAACEdFJOUwEIDwsFBwYCAwQTER4bJn4jDJFlTEQ2DhWgCqFUACoXXCAYhz52bRmGFi89IXUNLilsCVMUnzBdoltuRTVmS3eQTTxroSQiemSFH6VmEBJVGhw2HX0rJSckKE9KUVdCaFhwYmuCgoxuFyAuNzgxLV9ANEc7Rj8zPF5zppuKlZpym5WLnFrUtfgAAASoSURBVFjD7U5nV1tHEJ2AUoAUYwRCIKwGSMLoCfUGCAGmujvuvab3Xp3yxzNlZ99Kgjg5yYeXc3Lf7pR778w+AJibm4M5AL5SGJgKbC2EH3xBjbTAVOYTDuw20eaM1rtDX4f/8d/GqwSJkoA/BfhqP6Bn7hiTv1UvQI+gNfSuCxyC+VOvBRDB/KmRAIJ+KkTANMLBENKOaGKNrxQhtYdE8+1Uhcz2kD87Ysckj/Qq7vshCAUQ8EoAAS8HEPBSAAGlmRk8fGdKJckzg9k4BKWSEUs6UrKUldUrbUm1mZI/6WzveQKGx4cDhvFhGPfwY3jmjju5v5a+n+kb/lN4JnjHqp4HkaEIwcPjeRGtTTSECzR5ZKUB0YWIKGGmvb55d5U3SEU8++pQBIbODQUM54Zg7PxYwHB+DEYrowFDZRSmFZXpCp5pig4xbc+043T6io18K7JBPkfUruKuMS6rqAi5VDwXR+QIcaopmzIuhdGkiotimLgxO8jpkMm+nrNHWXknZ2tZDakMIpXig19GKkJGCdVSKRUzooshYz12h39TmjP+XMoYUzpqXxbTu3Dx0hsBw6WLcOXg9YDh4Aoc7Cwnl5PJZbwEzMvcMpukaCjjEbeEpDHrqDPouo2ZNLUkRRMiuez*4.2px7PzHuzcOEE4c8LijFO/AH/d+TdwYweuXX8zYLh+DW5ePWWwgh8dDAhTnrKUOFacqJKI/g6ZWTFrhBT7iu4zigjOCOHqTXi/trRUWCIUaoUaHawQ1DNdY7VAHTroYINsjS010smNBdl4qkZCwaypMVmgR0wrL1i/LfHQvo8+hs8+nJpanRJwvuw2vmaxuqo8nwHdjAyM60CPZ3V14I3LH3wNX3x6+vQ8HfwkzM9vYt4kUgSMjHkxULG5SQ4RdGqeLdxs6s55MqkopBA6x6IG0b/6Bu59Pumj3cY76RK9rVD9BZdtf0Mv2Z48amF7UBK63f7yHty+FQ6H18Mu1t2y2yew2HU7bLp2pNsNHwGV19e7On2sJ3zrNty5W47FYuUYx3JZSm7pCM+FOJz6gtFijseRY2VfL1s1ZkfMugtlZ5Lz3T*4.2px4JNEop5oJhJ4KSaa1NU514lqNhPaJhJ6mwkx1xPiFrEp43U16uZ6E1naVmeHPFavU8dMPWGfRvLbB/Do/sTaBGHt7IRizY97tnWAxNl+wsce9WsU9gZHj8GaU91/BI8fthYXi/i1FlvFLUxF7gitYnELY4u6YosLTMIUi3xZkokiDeAWpui+I2be*4.2pxzJ0OIWvYKuLV6vXoxb5tni4sPH8N3uwsJCJ09hgZDPS6APc14JZigt5I2xw4wcccsQG/K+o8MzHabMQEeXd+ygWCntPofdJ2/9Q7z9L48+2YWnP2bT2XQ6m9Vju2x2Py0tNvtCpX3VuqRJm2njNxWefTsn8Ius39stmH57Cs9+OmmwcdJBT9PDDCpHYWPDdW+4azZesOTXZ/DD943G7CweRFRvlBkhXTScgk+0geAZnqSyIR1Kxk8OZ0PDPNLwnxCyIWn28Hf4+TCKmKVQrcrFQFXUgnrmlfWLbW3Zsa02LKvbPSukqUZ1QPZuV6v2DUNXD3/5Ax+oMLyQMpayAAAAAElFTkSuQmCC)
    no-repeat 0 3.8 * 4.2px;
  background-size: 19.73 * 4.2px 6.13 * 4.2px;
  color: #18c5d5;
}

.auth-form-content input {
  text-align: left;
}

.auth-form-content input::-webkit-input-placeholder {
  text-align: left !important;
}

.auth-form-content input::-moz-placeholder {
  text-align: left !important;
}

.auth-form-content input::-ms-input-placeholder {
  text-align: left !important;
}

.auth-form-content input::placeholder {
  text-align: left !important;
}

// 小屏
@media only screen and (max-width: 430px) {
  .user-index .user-index-content .invite-code-box .time-box {
    height: 5.87vw;
    line-height: 5.87vw;

    left: 48vw;
    bottom: 1.33vw;
  }

  .user-index .user-index-content .invite-code-box .time-box .end-text {
    font-size: 3.87vw;
    padding: 0 2.67vw;
  }

  .user-index .user-index-content .invite-code-box .time-box .van-count-down {
    font-size: 3.87vw;

    line-height: 5.87vw;
  }

  .user-index
    .user-index-content
    .invite-code-box
    .time-box
    .van-count-down
    .day-label {
    margin-right: 0.53vw;
  }

  .user-index .user-index-content .invite-code-box .time-box .opt-btn {
    margin-left: 2.67vw;
    margin-bottom: 1.33vw;
    width: 25.47vw;
    height: 7.33vw;
  }

  .user-index .user-index-content .bottom-info {
    padding-top: 12.93vw;
    padding-bottom: 13.33vw;
  }

  .user-index .user-index-content .bottom-info .about-info {
    font-size: 2.67vw;
    padding-top: 4.27vw;
  }

  .user-index .user-index-content .bottom-info .about-info div {
    margin: 0 4.67vw;
  }

  .user-index .user-index-content .bottom-img-mask {
    width: 100vw;
    height: 15.47vw;

    background-size: 100vw 15.47vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .van-dialog__content {
    padding-top: 8vw;
    height: 93.33vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .bottom-btn-wrap {
    height: 24.13vw;

    padding-top: 8vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content {
    padding-top: 2.67vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .nickname {
    height: 8vw;
    line-height: 8vw;

    font-size: 4.4vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .tab-wrap {
    height: 11.2vw;

    padding-top: 1.87vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .tab-wrap
    .tab-item {
    width: 21.07vw;
    height: 9.33vw;

    background-size: 21.07vw 9.33vw;

    font-size: 3.33vw;
    margin: 0 4.8vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .tab-wrap
    .tab-item.sel {
    background-size: 21.07vw 9.33vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content {
    min-height: 38.67vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .nickname-update-box {
    padding-top: 13.33vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .nickname-update-box
    .input-box {
    width: 58.67vw;
    height: 13.87vw;
    line-height: 13.87vw;

    background-size: 58.67vw 13.87vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .avatar-list-wrap {
    padding-left: 11.33vw;
    padding-top: 4vw;
    padding-bottom: 2.67vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAc8AAAEBCAMAAAApRN7dAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAGMUExURTA2bjA1bzA2bDMzZjA1bzE3bTA2bgAAAC9MlytGkDE0bC41bjA3cCtHnC81bzA2byQ3bSxChzA1bi81bitGjyxFiy04dy40bC81bjE2cTA0bixEiSxEii84dC81bS82by44bypEjCtHjipFkCtGjiRJki82bzE1cFVVVS40bypKiitGjoCAgAAAgC82cC81aytHjytGjgAA/y1Lli82by41bi81cS81by80bTA1cC42bTE2bS80bS01cS81bSQkbTI4cDA2bipGjyxJijE0b1VVqhw5ji1HjzNEmSxIjy5GiytGjitGjy81by5IkCtGjyRJkitFjypVgCxJkitGjyxGjitGjzAwcCxDiDA0bytGji8+fC82bixChytEjDlVjitEjCxDiCxDiSxFizA4cTBQjytFjSxBiCw7di45dCxGjy82bi81bTA0bi45dTA3ciRJbSxDiCtDiixChi83cyxDiQCAgCxEiitFizNHjytGjyhDlCtFjCtGkDMzcC1LhyxGkCtHjy1JkitGj4h/mwYAAACDdFJOU4A1UAVqfnsAG9pJeYYSflUO0Dp4/t5JTn00a8/ejXxMN9gkVZUHd2kDThj3AgJyK/2sARFxSCtzMTA9LzYifgcpdq8jUwMJRA+SC7P4fCf0DlkGI92RVBDLRflSUdHcCejStOOFENnPRY/8aFJPkIYHz9/Kc9IC1eEZyRPbvhkRV8o/kxH4swAABpZJREFUeNrt3WdTE1EUgOELS1wrYIhAQu9FUSDYld5777333sHKHzeb3kbBUTEn7/sBmYyTmXueIdldwl2lh8l+fk9Qgz2dT406ewYlLevcHo5OhX*4.2px+OyuoLo7LFdGlo5uScs6O762p7BKK8odnOUVpVGw1jCeM0uPArqw*4.2pxoAjXzOSvtFIMzSzDU8d1fnp5dzHF0+cXd6chjnrshW+MBXoa3I84Dj27i/mG1jcyv2hk2OjRjraW41QOuv6g3O1mbjoZGxyZs+WezW5obtDy0mcIjG6HwP/GyOhyenbpFLwydneXp+dfdXnlry3vrs1Mpjv44OdtStZ7p5XQmJut7U0pbrWFbDpwbH19y2liZdT0zo+o1nM936CHYOjvxZVqZm1/eStZ97aslplv21h4Etqsgs3gBtz8s3QL8YnPl57QZnfISuZzHIZW3fkhYMqkI40zOUlJygBS5QJ2dBJHOGlpEeAqoEcwaCyuMMB6okc/pAB/QBgZxhQJVoTg/o8ND3oWGBnKGgPk9tYk4epxu0v+9bX79ETifo3IQW6qmZR8cXtpWSCdr7tVcmp1LbC+OjZi3YUzMnKaE5QXWpnM6SvKBKPKcHVDCnH6iSz+kCFc3pA1VRwOkAbfzcGC97iW5QFQ2cSlVXVUtfogtURQVnVOQEVXCKAlU1cAoCrVG1dcxBTHW1KiaTMYgpM0bF3GEMYrqDJ56EJ+FJeOKJJ56EJ+FJeOLJGPAkPAlPwhNPwpP+T08rnoI8rSobT0Ge2SorlTGIKTVLlZgYg5hMJSoFT0GeKfx8Cvv55P1T1vsnx7eyjm85/5R1/sn1IUmeXO/Dk/AkPAlPPPHEk/AkPAnPaPfk+q0kTz4/JMuTzw+Jis8PycpUgqcwT15vZb3ecjwk63iI8xVZ5ytcT5DkyfUhPAlPwpPwxBNPPAlPwpPwxJMx4El4Ep6EJ56EJ+FJeBKeeBKehCfhSXjiSXjS/+f5AU9Bnh+UNZMxiCnTqj5WMQYxVX1UxS+eMwchPX9RrPQyQM*4.2pxlulK18te*4.2pxYWAnr9qkw3PPXidxwTCTgWelesuzwr33POIuBc5X2l2/PZWzwFeL595vF8g6cAzzcez2Iz758C3j/NnvdP7SV7hEV+qS81j+d99vCL/Ez38cST8CQ8CU888cST8CQ8CU888cST8CQ8CU888cST8CQ8CU888cST8CQ8CU888cST8CQ8CU88CU/Ck/AkPPEkPAlP+uue7D8kIN/+Q+wPJiHf/mDs3ych3/597K8pwtO7vyb734rw9O5/y/7UIt4/PftTs3+8jNz7x3N/Byk57+/A/VckgRZzfyRJVX3k/mWijoms3F9Q1DnLB+7/KcqT+7niSXgSnoQnnnjiSXgSnoQnnowBT8KT8CQ88SQ8CU/Ck/DEk/AkPAlPwhNPwpPwJDwJTzxJgqcVT0GeVpWNpyDPbJXF3ppySs1SJex9KydTiUrBU5BnCp54Ep6EJ+GJJ554Ep70Tzy5PiTJs4Trt5JKzeL3K5K6k83vP0V5Wvl8gihPPm+CJ+FJeBKeeOKJJ+FJeBKe0e7J9VtJnvz9iixP/n5FVKlZeArz5P*4.2px1ustx0Oyjoc4X+H8k/AkPAlPPBkDnoQn/RPPTMYgpswYVVvHGMRUV6tqzEnMQUhJ5hqla4CK4dR0pQMqiNPwjAbQ6qrqqOB0esoHjW/83BgfDZwuT+mg8QmJemJCfBRwuj1lgxqcumxQD6fHUzKoi1M0qJfT6+kAHR1f2JbK2fu1Vyro9sL4qJfT56lrE3OW9AyZnP193/r6ZYJmpFvmJrycfp66lpwmD9TJWTA89H1ouEAiqIMzLdnH6e8pEdTFmZc/oA/k5wkEDeYM8JQH6uHMdSwuVyBoCGegpzRQf06JoKGcQZ5O0P21h4EtRjJnu4vziwu0PZJBF4Nc1vZDOIM9HaB767NTK4/9OjrYuf21mG5el8HZ1NJmcDZ8ajBA21qaDNCu33i229+GdOfgyJ9lZWp2fS+YM8RT312dn17OcXT5xN3pyWGcuyJb4QNfhbYizwOOb+P+YraNza3YGzY5NmKsp7nV8aW0/qq+1PFva7Px0MjY5E2fLHZrc8P2hxYTOERjdL4HfjbHw5NTt8il4ZOzPD2/uqv/ylPXZ5YeBXRhr9Qju9KK8qvyitIIX0Wl/SIQZmkm9D8pXX4G55UA0OsU1vP47K6gujssV0aWjm5Jyzo7vran/fyeoAZ7Op8adfYMSlrWuT0c3Q91eGs6bTrREwAAAABJRU5ErkJggg==)
      no-repeat 8.93vw 5.33vw;
    background-size: 61.33vw 34.27vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .avatar-list-wrap
    .avatar-item {
    width: 12vw;
    height: 12vw;

    margin-right: 2.67vw;
    margin-top: 4.53vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .avatar-list-wrap
    .avatar-item:after {
    width: 12vw;
    height: 12vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAADYn/qyizzss/Wl05jQm/jgp/3eC5khH9KCJ2qCN4cqZvDQj/lZo6Dwx/Tgq/jQk/kEy/l9N9Es09pKn9a+dwDos/1BC9DYm/09E/eeWuaiavUtN8Dsy+Tgo/jwy/k059Wpl4UZO7E5X9lBA9jYr+JiXvU9C+Dcm/7eQpYaT9oBW47B+v4qZ1XNy6m1X3nFa4p2x+uqYu01S/JGn+UIv9tqPwaZ+uY+Zyqar1jYk/2dk7eOTvDco/46i8pSn7Pq417WLpuui0bp9xmNZ80w6/Jym3jwy+4uc21E+9kw59DEj/62bwfyx14+j8kY097Z4znda2o6i5Gps+Hxa3sKTpc2Vq9yVsfKm1Y6XzYWCzZSWwY6UxrGewEhR8JeVvUdP86iStT075qKn2X5p5HBo6Kuo0beZtqyo1ZeG0VI/+aeNrUE8/Jiu+kEu+fq22taUstCPs0pH6vKo2EEz/Zqj3o2Q4KSZvbKOqLSfvE069J6z+jco/nNa2cyVr35W4uGUt6Oo2FJD80VJ8eKSvoyEzIuc2UNI7l9x6kJI8JWV35N6wkNF8nN197KSqo6c+qmOrJqt8beQp9qQueOUwZil4J2w+U9D/bOv0HJg26uQqrmkvZeP3FI7+I6g7sSSqsSNrdac4X6D1OaXw21g4p2Yvvas2a6iwHZy6YmW47GNr7+H41BO9JR0wK+pzktA/FdF8nN3/GN1/45p7Ec1+6Cn2nyI4KGWwamev/mpz0hG8YuX9YZg8Jh/zfCgxn6H6ZWp9L2QroRj5L2NoX6G2rKUsuiXxOmZw6eWtoib4qWVuEdD/ldH97qA2s2Z2smXuOarxMONzpJp65ur7p2t7a6JpDs946ms1YVd7VxS92ps/eSbz+yvz7WIx9Sgt5x8u9ykwPOy3PKjz5iu+pKAx31m0uuv11xD8eKoztegw6+Ipfaw3ZyXvOmdyfWu22ZX7*4.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)
      no-repeat 0 0;
    background-size: 12vw 12vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .avatar-list-wrap
    .avatar-item.sel:after {
    width: 12vw;
    height: 12vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAHrw/nD2/GP0/jP//3L1/nfw+nvx74T6/Xj5+3L2+3H2/Yn193P1/XH1+3D1/XH2/XH2/XH2/HL1/Hn+/4fp9IX094Xm+3D1/IL1+oHx85DZ/3v393T1+oX29nD1+3H1/HTv/5Tj/4Ho83b1+o3a93L1+nr1+3P3+YjY/nT1/nf0/4/g/3X4/Y/a+nL2+nb2/HL2/XD1/HL1/n72+nD1/XH1/pbl/4nZ+Hf194nw93f1/n7w/IXe8X/f9o3Z9oLv84Xr83f19HP1+3H1/HT1+nH1/HD1/Ifo9XT1/m/1+4D29ob1+Ina83z094rX+n3z+ZHg/37193zg/XD2/Yru93L1/nnw/43X/3Tx/47e/Y/e/3f1+4Dy8Yfk9H/x93T2+4nx95Da/3P1/nH2+X7x/Yb19ob19nXy/4Xi/37c94vZ/nL1/nj193309nL1/XL1/ILz9Ifn9Ibq83P2+4ja8oXw9nP1/n3o+In2+H31+nT1/ob19oT1+XPy/4Lh+4ja84fZ84/Y/47X/Xj193X2/XT1/ojl9Ive/3L2/IXq83D2/HTw/3Xv/4za/ojm9Yfg83b1+Xf2/X/083T1/Xv2+3X1/In2+H7t/HL1+4bZ8X/1+Xb2/YH1+Ibe8YXc74Xe8In1933j9n3b+4jY9X3b+onX+HX3/I3Y/4by9oHm/3L2+X*4.2px/4r294Xk9Inp9Yjo9HH1/YXj8of194f29nXt/ozY+XT2/4TZ8G/2+37w+Ynh8nz1+Yzt94f293T0/InY+Yfr95Ti/5Le/4T19Ibj8of19oXb8ofy94Lu8Xb194fx9nn1+Y*4.2px/3r1/Iff8oD0/HX0+Xvm+Ijm84nz9n71+ovX/ovX/4Tr8Iri83P2+Hve/IH19IH29Yno9Ijf9Ivc+47d/4Ts8pTh/4nZ8nr1/X329ory94n19ofp84fp8ojX+ID284Lu94bp84/Z+oXw84bj8Y/e+YLt9pHa/4L19IPb8Yrj84nw+Yrm9Jbk/4jd8obh8Yzu95Th/4zq9hQOKzwAAAD9dFJOUwARlwUBvgcEBQKIo/60jpx8rZSgDCj0Caf9nP0jR5NJgNniDETnS9hB/uHVuRP9VKfEkdbct7n5vR3ATe/++/v29yiNcmqxhP7RjG79/vrDFtD98atywtvK4g6H1c02+lHx982L8/5q2/35NxkwPU54x3rTb/ksyfL0z+e68O356b/w7TSxu8n+WKTK6d47MX9m3PXH4LiZ7ZzO5Kvvabnv7/39xPowO8/F9pPjy/3C99tvZbTz7YqDPvzz8vTGYIn++/zxvukii85Yj+V96sz2Xff0oNXHgs/4mPjBvexGmD+f9O7mc+HPqthcpv6v+MrP7/D//v///v////6J/QPtAAAIHElEQVRYw7WZf*4.2pxT5wGAjySXAGe+wcQKJQ4KNcwCCaFGwbpAEhKEoQ1BsGO0ILAhBlkgrCDaCqEMIh8GSoRqaxm60iFqmVNpsaWrG+1osWqn29Suart1218CdaLd+97lJFQYSbg9/wAJv+f35L334w4QZG4YAbWFL1+48DLBo9/hww9/DwFfCren+yGewVSduPDOV1/9muAdyA6cX+GscVJ9ISNH5JmZpTzx1pev/Zxk6WyeneHLNRmBLI/MQSfeem3JkoIND1g2MbEJZ5krG7659/aajGamZ80fLFmyYecrXYBYgoiLETixEbGx7e1dXTfHxoY+WfbN*4.2pxdBt6/b5kC8eWnXM3a0g13X3R0djWGYkADDoqO7u+vYHVbUrmsb+4To9nW7uRo0L223K8QYlybT+2u1EomERwC+02r1HBmNixkURt1Nwh3I9KQ51moAALmDJpBx9Pp8f0i+HmhlAhpXKOZrNOy4vHbCXeFGNzOosBqYd17swGh9VxzCK1f6+jj5+YQYlwMSOfAtR59AqIlp30p0LzgHWapCeAV3XqzjYonjwSHhIcHBYWFhj88GvALeCg6L4nH5xrat9769ejSjYoE5KCKb62h6jjqISUJn0knAD3Ty5W3hpQKxNSL+3W/fPrpANyuwEF7Bnc93CwTaBtXCn1EZUkrDoPvOAt1E8wZglmklw0FurDI/pamUI+yIBO6Bo8fn7wbN+Dg/H83RS6KC3NobmMpwngy6k+9c/d3x+da8CIzG+wUF0CwpbQhiubsKTEl6Lhu4pz4FbubczSnVH+DmRH9JrtLtfQFcSx7HAdz9U6D73BxFzIrC6qUFBa8AszYpSsXyZC/LTcoH7s7+adjt+/D7hbAZN3vSTHSbJImE+9WHu5kVKXCc*4.2pxgmukxJiWC8K/unzxw8MPtasoJS/kKaJVFKuodHEkLfZuLBa1k5DboPKF3crIqUv75fMAHMHH/Pm4m28CSO0CqvnE541bXbFzZPAHM3RysZVXphBm7QzcHi5JUJ0E2ON96Mm2WcUq+ayW4BhhYRbrybIQLN+4D5Yp1Aqx1XemkmumVi1FaZMAm7mQzEp+QWbB4Cex1NMqpiIl4D9yoH3yKtTEjdffBArw+yHW8eimBz9f6tQSxkEbDAuqSxG5vOT4Lu49eQW//sAuZ2q1DIGVeJkEXBUgbzMFTedD5hcvfBs8gjP9o3kdZu53NlahULWSR+oBuLOVZzaLJ89wtQ*4.2pxlIp2ALW1WhyKKhbwuW8POqBtel3tiPq8csBkdpCR2hAL/0ED3MTr3RgzyyY9+mjyxidUUoQgmsbWoUqOGAPLpjX9pHedhaEUIRzCiFq9ouNIVSp9bIqw6lwsu4Y31au9FhCqBObdA1rXsKnyHr09pQ2lrq1LnivCxC/Yf1aRFWWTh1ahNmmaUOoVAtjLHNqDs4FKrDuUagfsypZidSqy56oH6m7mQwhWoHCtWrCTX7ZDB18zqEBtRPkOq6k2GUqlfMqDUUq12r/Sl*4.2pxzMJ9Z/W/5h69S5C/QPK1WjmrhGg/tv/Wa2hfEBGvvd9Qs2mUh0Oq997oKZy8oHVOKMGe0gwpXuIU/0zoKZ05wObauauJ4H6F7i6j1K1PfMnpLrN2hdO3ViDU+bNGTV6ZS11anA2uqhjHLmUnugzaqldSKG6QSPvJNWnpZboKArViiJSPXD6po4/Spla1BAnjX+gHpNrRqm652Okq2Nc1cfYoxTNEIbPKf/Gqq24+u//GPjXkBTl1VIyIn6rTpXydU41qH73dFWehkfFrTsDmMWNbfFvvATVZf++mpy8Varjmxff7Zd+KgmzS4H5/hcbryPXyuoHoNtoWPQjBxiNJC54AHvjpf+8t/H6ASQ9p+zop3eS49vyxOoS0SKbzTSF7k1gfnLjlmuBiJ8oMKN+ALiLrJhZRV9Us1nAtjjNe33gk6JvM+ieSo6PNNJaS5jeN29X9/EtNnw0tnye7VyagWX1cEwiFZja24d01qrtKYkGY+bTRHM2g1z2YLwvTyV3RqKC1hJfL5tbE8XQfN+lmfjTU1n9mak7nZFxoFvkXbNejELzFxu3FM9a2aE5ZfWXcbdA7fkchM35GLri6ZX3R2Y3493NsHuqUxcnVqsCvBhnMTSPwOaHPjXR3Q+7zbV0j8cZb749Aq/gw8uf2dwCuvs7dVbwwB7gSfNhZ/Pt5+ZqhmTntNRfvgvcbMetWqb7O9LhVqd5+ZG5monunJaPz9yd7tQZDeaSALebzTKDEW8+8tleEWOegOzmlo/L7/ZXgjnIc68bNIM1SJqLfRjz/iLRndCps/CT3NljgdlMY1tsCzQT8wTvTqgsQg28hfcThs9hs0NBmouzGf/7qM9xuvMMC3aDMyUJQ3VZ0Lz5s2IRY4GS0N6W/eV3Jyuz7BpebWjAqlU+85GtfBycVvKsP+PNvdlu3Efk/HZ/eerk+Sy5RjI8PDze0BCVm5trMq0lMeVGRTU0jA8Pm/35jdImaN78x2K3dh5RL+FukjeiCo1BjAkdNJpA0CfD6RMIaA4hJjZoFGijnDT3unmvISom3DVV0mNyXZ4lxoiicQAFAHxBUWNMY55OfkxaVTPobHb7LkbUjLsPDdbUNDVlZWXZbCtcsdls4MWmpsHBwddX3n4RNHtwfoTuxd2T63B++h1+ifM6ZOXy5y550ExeyxvlT5E8McPy2ezxrBnfq66d7dl94zGC35DsIXnRyZ5LZz/P9vRIOvf19Z6eFwCrV6/uAfzQlUs4mzcfuXT963Pz/Yv+v2X703PppdVZAAAAAElFTkSuQmCC)
      no-repeat 0 0;
    background-size: 12vw 12vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .avatar-list-wrap
    .avatar-item
    img {
    width: 11.47vw;
    height: 11.47vw;
    -webkit-border-radius: 5.73vw;
    border-radius: 5.73vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .update-content
    .opt-content
    .avatar-list-wrap
    .add-btn {
    width: 12vw;
    height: 12vw;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAKmYvLWwzm9Sz3hW2c6YvY6i8qSf3Kai0K+au5eYv5yx+eaVuzImyqqq1JyZvpCl97iSpFpYx0Ex9NSdzI6b0ams1pKn99Saq5aV*4.2px1d3qygviceyp6Jy9+Ru7t9y4iGyuOUwZmm4j4x2O+u2ceWo7iivLSLqI2Vymxr3Jih17eXsv281uKXsZuv+ayNrUUy+IRg7cmOscSEwueYxqOo2ZKYyIGI1I2c1rKbu6qo0aiWtJOJyZir6bOfvjwt4n1W44qZ2J+z+iMrfpGg+bKPqV9e3IKR5b6OrpSp88CPpcmTrCsg2bWEt25R32Jj6aGXxn+J4q+Kpmpu7oqc5qiNrPWq2Hpg1WtZ4y8i+YeW8fq228aL3isf99aWvOKUtysmuOyezKSavo+c05Om4WlV1I6h4oye56qCs/Wpyt6i30w59DYm+/Sp2OWVvqiRrTkt0KecvyQcyUY34iEdv+ycvrKOppp5v/yw19KSr9uUs/Oq2ioh1eCUv7yFu5uk1eiWxJmp56eYvcuYu++y0beSpzEm5O2gyWBf1KSUtqKUvSQphi0i5tGct+Cnw+SrvCcnnOa*4.2pxe+fyiYrkB0laSsptBAaRjEu0zMu35pq5KSo1nuC+o2D0IaT2AwXPQ0YQMer9g0YQsyr8vCr2BAcRc+r8NKr7sqr9PKr1uqr3Dcxvuer3hskaRIcUeOr4SAjjyIcrpV+uRYZeSMdsxYfSCMgqeyr2x8Zn4V4tiMmd9ar6yIhmRgkViAbpyYguBsfdu6r2TowyBkjYiMkoToyxLqGrx0lb2Vk0BEbSp2y+Sckrp54pfSr1Twxzh8Wuh8qeCslpsWr9yIsbTUwtaKDuSstV42U3ot7umZUxyQbvxgXra6RqryovCgiwa1/qbKDrrOmwJqv8+yZtycviVhc1Sw1oZeZ3X5lkyYslzYmy0I+ai82q7aMw/6y1JN3qtyo4CoyndOg166HvGtdkF9Uhb2a11JJdrySysiY0JaQ1C01kLSLqYpvn8qk5JCc7URCyrLXCqwAAADydFJOUwAp/PzjCicDBzTS8fv4wPdo/PzQD830uP2l3/r+78r3/H+U/bn8+MKe/v38+v2badvvxPw3kPf89H5x/v3+yd/pnMv+/s79/r7t6Ore+vLmHfmI9m+60Pvlu/3i99DD8f2IedX+6fe//vz96t4+z/HxxO319/zt9vjt7o39/vnMK8xvvOPq8/3ywELpx+bm/es90bLuyuefhveL8/T0///////////////////////////////////////////////////////////////////////////////////////////////////////////////+wj4AHgAAB7BJREFUWMOl2XtUk3Ucx/EJ4aAwI8jITckWmplBpWUiTSMza6FohZQUmpqEFSFoFyy7eUFLTe1+mBNRuW40JhlsNZiXZkNEUZfNSMoZGYRXMu30/f1+z/Ns043f79k+/3jEc17nfX48zzO3SSQ+FtX7ujtdu8VjI2FfoI38YnTBZKlE3EJBflDYO2jPk72Ndi2/kaPDQsXJ0t7X3TjxGmGJiYmzbndbP9euHd1LKla+5ocfHuL2H+ygsOMHj/O7HdtiuqWTifzlVLSheLs8Rn42NOV4vyDUHSqy+empWQqb2WwpRduP9ud+bqWlFovFbFPMH3qwX1AQezfX/PRUhbyxUa/TGY01njPCdDq9yS7PVzz8TxCy2br55odtdrvdlGGyWq2GBvcZDAb4WUaGw+GQy3k7TMp01RHZbNJZ/4T9Dvv7BOxv+JMM/Qj9k9VqctiYu4Vmi76xKal5J1n5ZeN+vPO7Wr3DtouzpYzNFp2xqa1Oo9ao3abx/JtaXfFdrc5uRnYr2CHUOwXJpTpdw946TSFl2DaZd40JCpK9+m5P3ah54q+/IrmmNqlOXVjIYhtMlsNjWluRHdpjM8i/lRqMtQzNaBrcLdjSnptBrgFZXcg01G3Ugy1rlS330c01TyDNFYwy6TZgW5aw3Gt3qEuu0TI3c91ao770cFVCQsLyuCu73ZprGvZWaApFjO8G+5XlcZe/NIT2fuKFiYmJ+DTENfPdBug+BPaTcZ5nInXJqFmkzF+D+EzAdu+WBtQsdMM1eCjhiEc3Oo05ATS73ztVR464dUuxPCvlt1KdsdavZt62Cjbpxs2zZkGzrqYhqcJPmet2mPnuUCn8fwPLKdwTyW+Z2PCMBTtiAXRHSQqQPCdlUh+9saEtENndPgJ2geSJcaPmgKxshCd/3abCwkBtk1wRvBDZUyTjbhh1MGVSZI6+KcBmwc5XzEZnMkQy7vlRE6ZGquT723pudu7g5+zZbnDkz0+dG7FgPKpG0dYL9T03H/0Rb+*4.2pxrXso3Yb8JckHIj4YwtG5bbRzPkpcGg22Vu5OKzO20551R4lbVFS0h/Ic/FqucKPnZ2zfxEIDXPQ9lbYrgnn6vknZTHQRlhloW/DcWJ62WZno72HbtlFpk+3w3NhHCb3MbN1JpYuwu62khJF+RHIbpg10GsElJSVlZSLoe+9bZmkqp9NILitjoPXmw6diHyP09ZYmejVJLqvsdLLQ0S66mUbvQXBlZWXnqXZRdKl3+uI*4.2pxo52lXHyuZaWMx0HuDn9pXegexsuZe6UQe46cK66/eLZb/lV+aBPRn/4HgMNlwZ3GJVdHeda3GXvtI6JRs2C3NnV0d7S3gHyZn4+6GBCX33vzT5pVzPQnd0X2+vOVV3i4OLi4s3FPulVVJocNGnudra3gEzU4uKNGzcW+6TPr/qIQmOZ0J3nnXBpHLiE4Y38vNJWTD9LoYWD7jx/GuRTlzh4CzdfdDcbjeWTIJ8+iZI5eAPeIe8XX3B3JtA3Xd0X0V5v9B2CfOoMyOeJ7IJ90bbU7sz3b8X0Mov3J59zD15Hh7O9rsV5lpPPfuPaaR901x0cPdtCf6ie4eUt39Afqi66v4X+UtDByxvE0dnWvTS6CmgsM9CK1BfF0RCNf38M9F0v3vEMRysz6DRc0FvYaIc7HclCw3Gg620fnZ4v0GP6R+YksdL76LTcg15Jp8nvkInOch3ItPi0FRo2eh+V3q3Nd9FjgF5bTaW5aAq9u9y4xI1OjU/7dN0mFnofhVbvLq/NnZf1eRlHQ3Zk2nrKf91PH+J3pqfmeq19Sfxd04sQPfOmvrK+X02LX7m6PsA3Sai5XmuCk56+7a/XnnpTUjDzVZlMBt2qE/WBvk0CWQ9X3vQiJA+STA4Du1U2YFpkjrZeE5BcUa7VIflHJL+0WCIN6YXs1gH9lbnagN7s7kaygpej0Lv0UNT9M7L1AXSrK5rbDHbF2Olbicx9aNFr5gODkZ3dqK3T+NvcfMFg/yOZbxY+EAnj7D46bb3a7+bGP4Jx8wyXzHf/PGB2H5PWnzfq6urmC0YkZ/6V+dSMER4froaE3Y+7Z/vVjZqRHLM0M/Njj2ZyJvdz3XbR3ficBXnEFR8Ik+7BfnSDjM85ZtHSpVc2X9bdJuaeh+uZNOfl5Xlrxl9NCd0mMfc83CmkOS/v5Rlronx8FMzb2Q4taze6B+F6Do4JB3nQCJ8fvOPuwcMG9FflsnbDE0kH78ljFh0LBznK9+fuqHvYMLCVOWzd5LlxVUw4ktf09GWBFK6T8diOVK1m6AZZL1eO5ZspX3EQeyG8yK9fV02VT+Sq4seS5hEhtC9muO6F8Jr26dpPPqn2vU1161ar0gU5iuHrpLAp4yMi/l0IL/OffbZ2xYqkpO1elpTUtmL1+jROHsjQTLp5Oz0tLW2lKidXr//JY/rG3NwcVXp6+jxeXhzC9tUdbydnzZsXHwlTKlXZfVzLVim*4.2pxMKy8G+QtdndTk1Ovsr7xqIlJ39O5MUh7F+TcvYvc2GPC3sL7x73LQoX1czbCyJi+UXHRnMbHj2cX/jwY8eOPSeuGd/zBVOGLHiU7DG818neIHuO28BBa6IkIr/t7hU3ZQjeI7C73fcs2kBuM+IW+3pu/A+BFhCKl64FWgAAAABJRU5ErkJggg==)
      no-repeat 0 0;
    background-size: 12vw 12vw;
    float: left;
    margin-right: 2.67vw;
    margin-top: 4.53vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .user-avatar {
    width: 39.33vw;
    height: 23.6vw;

    margin-top: -8vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .user-avatar:after {
    width: 38.13vw;
    height: 16.8vw;

    background-size: 38.13vw 16.8vw;

    left: 0.53vw;
    top: 1.6vw;
  }

  .user-index
    .update-avatar-nickname-dialog.common-small-dialog-wrap
    .user-avatar
    img {
    width: 17.07vw;
    height: 14.67vw;
  }

  .user-index .bind-invite-code-dialog .bind-invite-code-content {
    padding-top: 17.6vw;
    padding-bottom: 7.87vw;
  }

  .user-index
    .bind-invite-code-dialog
    .bind-invite-code-content
    .code-input-box {
    width: 59.2vw;
    height: 8vw;

    background-size: 59.2vw 8vw;
  }

  .user-index
    .bind-invite-code-dialog
    .bind-invite-code-content
    .code-input-box
    input {
    height: 7.6vw;

    font-size: 3.33vw;
  }

  .user-index
    .bind-invite-code-dialog
    .bind-invite-code-content
    .code-input-box
    input::-webkit-input-placeholder {
    font-size: 3.33vw;
  }

  .user-index
    .bind-invite-code-dialog
    .bind-invite-code-content
    .code-input-box
    input::-moz-placeholder {
    font-size: 3.33vw;
  }

  .user-index
    .bind-invite-code-dialog
    .bind-invite-code-content
    .code-input-box
    input::-ms-input-placeholder {
    font-size: 3.33vw;
  }

  .user-index
    .bind-invite-code-dialog
    .bind-invite-code-content
    .code-input-box
    input::placeholder {
    font-size: 3.33vw;
  }

  .user-index .bind-invite-code-dialog .bind-invite-code-content .input-tip {
    height: 6.67vw;
    line-height: 6.67vw;
    font-size: 2.67vw;

    margin-top: 1.33vw;
  }

  .user-index .bind-invite-code-dialog .bottom-btn-wrap {
    padding-bottom: 7.73vw;
  }

  .user-index .bind-invite-code-dialog .bottom-btn-wrap .tip-text {
    font-size: 2.67vw;
    height: 8vw;
    line-height: 8vw;
  }

  .bottom-btn-wrap {
    height: auto;
    padding-bottom: 9.2vw;
  }

  .user-index .logout-confirm-dialog .logout-confirm-content {
    padding-top: 22vw;
    padding-bottom: 18.67vw;

    font-size: 4.4vw;
  }

  .user-index .logout-confirm-dialog .bottom-btn-wrap {
    padding-bottom: 9.2vw;
  }

  .user-index .logout-confirm-dialog .bottom-btn-wrap .btn {
    width: 35.73vw;
    height: 8vw;
    background-size: 35.73vw 8vw;
    line-height: 8vw;
    font-size: 3.33vw;
  }

  .user-index .auth-real-qr-dialog .auth-real-qr-content {
    padding-top: 15.87vw;
    padding-bottom: 9.07vw;
  }

  .user-index .auth-real-qr-dialog .auth-real-qr-content .qr-box {
    width: 44.67vw;
    height: 44.67vw;

    background-size: 44.67vw 44.67vw;
  }

  .user-index .auth-real-qr-dialog .auth-real-qr-content .qr-box .qr-img {
    width: 32.67vw;
    height: 32.67vw;
  }

  .user-index .auth-real-qr-dialog .auth-real-qr-content .bottom-text {
    font-size: 2.67vw;
    margin-top: 12.8vw;
  }

  .user-index .menu-content {
    width: -webkit-calc(100vw - 5.33vw);
    width: calc(100vw - 5.33vw);
    height: 100vh;
    padding-top: -webkit-calc(var(--head-height) * 2);
    padding-top: calc(var(--head-height) * 2);
  }

  .user-index .menu-content .action-list {
    width: 94.67vw;
    height: 33.07vw;

    background-size: 94.67vw 33.07vw;
  }

  .user-index .menu-content .action-list .action-item {
    line-height: 10.93vw;
    padding: 0 5.6vw;

    font-size: 3.33vw;
  }

  .user-index .menu-content .action-list .action-item div {
    width: 19.73vw;
  }

  .user-index .menu-content .action-list .action-item:hover {
    background: url(data:image/png;base64,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*4.2pxYHAD9+VBvOamabu1UMfqx8Cfrj+9OtibPZQKIODQqkGQYBu6Np41QxGR87U8pjzQ+T4vnmleeiFi7qg5CXae25YkU9x14JkfemuwFqj1m0E6t/SmJRDHjj6Uksj89F2IeWX/6*4.2pxMTz65wsyBA4nkgsWmWy/XTsTq14FDgGbEVZTzmfA/zTKAcLLK9BYE2bTxfD2GzxpcBYlhIpWVmseP/3kGqz/XCdSArqJ4+BEP8ACHNCRtWQaiPbs5rw644+DgkMDBUe878uoZrO72GqsMPaUrjeLfU4iAU/LL83ecQrTRPV3A3XkBHFOyXJT5G6Fee71dZlrSW0WUy3vKrLNuF1XtWILIrGvXP4JNfLFVyKKkqH/85Qz2yGtPPhqMVtuzylTK+4szUbhUYVmHD0HArXsCe/ZAM6hcjudBCfqdUNmWxdkq8f9LOnBKVfHyw9mQrL3n6HNLW21BgLUufe5XoEyJ/pZq1YiNwPk9o72vDAqOXnHtvbfDfUisCR9c/fr59gRTosVSPVr7oFG44vBM/wWZEJKw6J3LHJji6X3l/c+NMlPmYv8l+lGbI9Fw9GW62OkmqZ7vlzKZaMfvSuObjcvtzpZKH7XlgKaYvbV3erxAmeIWSAuUs8QCaVSpbsB3z+jqrvPdH+lfTPR5MpXoyKrifF2GWvHg9k0jpSjUS2ItYaAvMcgUkHQhFf5gOIl5yFDjdCULs8JAkOREys3rjUglFPVho8JUb/WkBVXlKg5TzNM2Re5KDWU9VAE3GbiBw/lhQr06pCmyUChiudGpYxmDWKHSjPT8jqLMxgKgfMakhty0/H0XtuyOB4o8xtkXlCVRfMS0rbHbbCKDnDzmifmu23FRIxmPAg4MvfoooWh8yjliBym9UuSBI6u/AcTpGABHGPMNAAAAAElFTkSuQmCC)
      no-repeat 6.27vw 1.2vw;
    background-size: 7.2vw 7.47vw;
  }

  .user-index .menu-content .action-list .action-item:hover div {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAAAuCAMAAAD5s8D1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAGMUExURQAA/yBg/yJV/y5d/zNm/yRJ/ypV/wCA/wBV/0BA/yhe/y1a/yJd/yZe/yhe/yZb/yRX/ypV/ydb/yZb/yVb/yVe/yZe/yRb/yRV/yZb/xpm/yZc/ydb/wAAACRb/yFZ/ydb/yhY/ypg/yZd/yVa/ydb/yVb/ylc/yZb/yNd/yZc/yZc/ydd/ydc/ydi/yde/yVd/yZc/xxV/yhc/yZZ/yZb/yVa/yZd/yZb/ydc/ydd/yVc/yZb/yVc/yVc/ydc/ydc/yhd/yZd/yZd/yZa/yNc/yVa/yZc/yZc/yZc/yla/ydb/yVa/yBg/ytV/ydd/ydi/yRb/yZa/yNh/ydc/yRZ/yla/ydc/ytc/yZg/yda/yZa/yZb/yZb/ydd/ydb/yZd/ydb/ydb/yZb/yda/yVa/yZb/yVa/yxk/yhg/ydZ/yVd/yRb/yRY/yhb/yZb/yhc/ydd/yha/ydb/yRb/yRZ/yha/yZZ/yZa/yZb/yZc/yZc/ydb/yZc/yZb/yZc/yZa/yZb/ydc/yZc/z/uhBcAAACEdFJOUwEIDwsFBwYCAwQTER4bJn4jDJFlTEQ2DhWgCqFUACoXXCAYhz52bRmGFi89IXUNLilsCVMUnzBdoltuRTVmS3eQTTxroSQiemSFH6VmEBJVGhw2HX0rJSckKE9KUVdCaFhwYmuCgoxuFyAuNzgxLV9ANEc7Rj8zPF5zppuKlZpym5WLnFrUtfgAAASoSURBVFjD7U5nV1tHEJ2AUoAUYwRCIKwGSMLoCfUGCAGmujvuvab3Xp3yxzNlZ99Kgjg5yYeXc3Lf7pR778w+AJibm4M5AL5SGJgKbC2EH3xBjbTAVOYTDuw20eaM1rtDX4f/8d/GqwSJkoA/BfhqP6Bn7hiTv1UvQI+gNfSuCxyC+VOvBRDB/KmRAIJ+KkTANMLBENKOaGKNrxQhtYdE8+1Uhcz2kD87Ysckj/Qq7vshCAUQ8EoAAS8HEPBSAAGlmRk8fGdKJckzg9k4BKWSEUs6UrKUldUrbUm1mZI/6WzveQKGx4cDhvFhGPfwY3jmjju5v5a+n+kb/lN4JnjHqp4HkaEIwcPjeRGtTTSECzR5ZKUB0YWIKGGmvb55d5U3SEU8++pQBIbODQUM54Zg7PxYwHB+DEYrowFDZRSmFZXpCp5pig4xbc+043T6io18K7JBPkfUruKuMS6rqAi5VDwXR+QIcaopmzIuhdGkiotimLgxO8jpkMm+nrNHWXknZ2tZDakMIpXig19GKkJGCdVSKRUzooshYz12h39TmjP+XMoYUzpqXxbTu3Dx0hsBw6WLcOXg9YDh4Aoc7Cwnl5PJZbwEzMvcMpukaCjjEbeEpDHrqDPouo2ZNLUkRRMiuez*4.2px7PzHuzcOEE4c8LijFO/AH/d+TdwYweuXX8zYLh+DW5ePWWwgh8dDAhTnrKUOFacqJKI/g6ZWTFrhBT7iu4zigjOCOHqTXi/trRUWCIUaoUaHawQ1DNdY7VAHTroYINsjS010smNBdl4qkZCwaypMVmgR0wrL1i/LfHQvo8+hs8+nJpanRJwvuw2vmaxuqo8nwHdjAyM60CPZ3V14I3LH3wNX3x6+vQ8HfwkzM9vYt4kUgSMjHkxULG5SQ4RdGqeLdxs6s55MqkopBA6x6IG0b/6Bu59Pumj3cY76RK9rVD9BZdtf0Mv2Z48amF7UBK63f7yHty+FQ6H18Mu1t2y2yew2HU7bLp2pNsNHwGV19e7On2sJ3zrNty5W47FYuUYx3JZSm7pCM+FOJz6gtFijseRY2VfL1s1ZkfMugtlZ5Lz3T*4.2px4JNEop5oJhJ4KSaa1NU514lqNhPaJhJ6mwkx1xPiFrEp43U16uZ6E1naVmeHPFavU8dMPWGfRvLbB/Do/sTaBGHt7IRizY97tnWAxNl+wsce9WsU9gZHj8GaU91/BI8fthYXi/i1FlvFLUxF7gitYnELY4u6YosLTMIUi3xZkokiDeAWpui+I2be*4.2pxzJ0OIWvYKuLV6vXoxb5tni4sPH8N3uwsJCJ09hgZDPS6APc14JZigt5I2xw4wcccsQG/K+o8MzHabMQEeXd+ygWCntPofdJ2/9Q7z9L48+2YWnP2bT2XQ6m9Vju2x2Py0tNvtCpX3VuqRJm2njNxWefTsn8Ius39stmH57Cs9+OmmwcdJBT9PDDCpHYWPDdW+4azZesOTXZ/DD943G7CweRFRvlBkhXTScgk+0geAZnqSyIR1Kxk8OZ0PDPNLwnxCyIWn28Hf4+TCKmKVQrcrFQFXUgnrmlfWLbW3Zsa02LKvbPSukqUZ1QPZuV6v2DUNXD3/5Ax+oMLyQMpayAAAAAElFTkSuQmCC)
      no-repeat 0 3.8vw;
    background-size: 19.73vw 6.13vw;
  }
}
</style>
